
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iBtX5", function(module, exports) {
const $49d505ddbcfe4978$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>permissions[product]?.[permissionId]);
};
module.exports["hasProductPermission"] = $49d505ddbcfe4978$export$a2eea90ce05a9f1c;

});

parcelRegister("kdU21", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $11f3ff053e659fe4$var$JIRA_SUB_PRODUCTS = [
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery'
];
const $11f3ff053e659fe4$export$29429bc4d26dfcf8 = ({ url: url, query: query, variables: variables })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
};
const $11f3ff053e659fe4$export$98fa14561e3049ec = ({ url: url, body: body })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    });
};
const $11f3ff053e659fe4$export$e16fe80afd1ad74c = (cloudId, userId, productPermissions)=>{
    const body = productPermissions.reduce((acc, productPermission)=>{
        const permission = {
            permissionId: productPermission.permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        if (productPermission.product === 'jira') $11f3ff053e659fe4$var$JIRA_SUB_PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        else acc.push({
            ...permission,
            resourceId: `ari:cloud:${productPermission.product}::site/${cloudId}`
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};


const $271938b51863a92c$export$544dab20dbe3f2e7 = (product, permissionId, cloudId)=>{
    if (product === 'jira' && permissionId === 'CREATE_PROJECT') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateProject($cloudId: ID!) {
						jira {
							canPerform  (cloudId: $cloudId, type: CREATE_PROJECT) @optIn(to: "JiraAction")
						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_PROJECT',
                resourceId: 'jira',
                permitted: response?.data?.jira?.canPerform || false
            };
        }
    };
    else if (product === 'confluence' && permissionId === 'CREATE_SPACE') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateConfluenceSpace($cloudId: ID) {
						siteOperations (cloudId: $cloudId) {
    						application
  						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_SPACE',
                resourceId: 'confluence',
                permitted: response?.data?.siteOperations?.application?.includes('create_space') || false
            };
        }
    };
};
const $271938b51863a92c$var$fetchPermissionFromDefaultEndpoint = async ({ cloudId: cloudId, userId: userId, productPermissions: productPermissions })=>{
    const response = await (0, $11f3ff053e659fe4$export$98fa14561e3049ec)({
        url: '/gateway/api/permissions/bulk/permitted',
        body: (0, $11f3ff053e659fe4$export$e16fe80afd1ad74c)(cloudId, userId, productPermissions)
    });
    if (!response.ok) {
        const errorBody = await response.json();
        const errorMessage = errorBody.message || errorBody.error || `HTTP error! status: ${response.status}`;
        throw new Error(`Failed to fetch product permissions with error ${errorMessage}`);
    }
    const bulkPermissions = await response.json();
    return bulkPermissions;
};
const $271938b51863a92c$var$fetchPermissionFromRestApi = async (endpoint)=>{
    if (!endpoint || endpoint.type !== 'rest') return;
    const res = await (0, $11f3ff053e659fe4$export$98fa14561e3049ec)({
        url: endpoint.url
    });
    const responseData = await res.json();
    return endpoint.transformResponse(responseData);
};
const $271938b51863a92c$var$fetchPermissionFromGraphql = async (endpoint)=>{
    if (!endpoint || endpoint.type !== 'graphql') return;
    const response = await (0, $11f3ff053e659fe4$export$29429bc4d26dfcf8)({
        url: endpoint.url,
        query: endpoint.query,
        variables: endpoint.variables
    });
    const responseData = await response.json();
    return endpoint.transformResponse(responseData);
};
const $271938b51863a92c$export$dcb450c551529da1 = async ({ permissionsToCheck: permissionsToCheck, cloudId: cloudId, userId: userId })=>{
    const apiCallPromises = [];
    const permissions = [];
    const productKeys = Object.keys(permissionsToCheck);
    const errors = [];
    const productPermissions = [];
    productKeys.forEach((productKey)=>permissionsToCheck[productKey]?.forEach(async (permission)=>{
            const endpoint = $271938b51863a92c$export$544dab20dbe3f2e7(productKey, permission, cloudId);
            if (endpoint) {
                if (endpoint.type === 'rest') apiCallPromises.push((async ()=>{
                    try {
                        const responseData = await $271938b51863a92c$var$fetchPermissionFromRestApi(endpoint);
                        if (responseData) permissions.push(responseData);
                    } catch (error) {
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                        permissions.push({
                            permissionId: permission,
                            resourceId: productKey,
                            permitted: false
                        });
                    }
                })());
                else if (endpoint.type === 'graphql') apiCallPromises.push((async ()=>{
                    try {
                        const responseData = await $271938b51863a92c$var$fetchPermissionFromGraphql(endpoint);
                        if (responseData) permissions.push(responseData);
                    } catch (error) {
                        permissions.push({
                            permissionId: permission,
                            resourceId: productKey,
                            permitted: false
                        });
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                    }
                })());
                else if (endpoint.type === 'default') productPermissions.push({
                    product: endpoint.payload.product,
                    permissionId: endpoint.payload.permissionId
                });
            } else productPermissions.push({
                product: productKey,
                permissionId: permission
            });
        }));
    if (productPermissions.length > 0) apiCallPromises.push((async ()=>{
        try {
            const bulkPermissions = await $271938b51863a92c$var$fetchPermissionFromDefaultEndpoint({
                cloudId: cloudId,
                userId: userId,
                productPermissions: productPermissions
            });
            permissions.push(...bulkPermissions);
        } catch (error) {
            errors.push(new Error(`Error fetching product permissions with error ${error}`));
        }
    })());
    await Promise.allSettled(apiCallPromises);
    return {
        permissions: permissions,
        errors: errors
    };
};


const $83cc7ad61bf4f552$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];


const $e2f95f239ab54f09$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $83cc7ad61bf4f552$export$69caceff42c0da80).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};


const $21a370a6c94ec1e0$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionsToCheck: permissionsToCheck })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionsToCheck.jira?.some((permissionId)=>permissions.jira?.[permissionId] === undefined) || permissionsToCheck.confluence?.some((permissionId)=>permissions.confluence?.[permissionId] === undefined) || permissionsToCheck.loom?.some((permissionId)=>permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const { permissions: permissions } = await (0, $271938b51863a92c$export$dcb450c551529da1)({
                    permissionsToCheck: permissionsToCheck,
                    cloudId: cloudId,
                    userId: userId
                });
                dispatch($21a370a6c94ec1e0$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($21a370a6c94ec1e0$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ getState: getState, setState: setState })=>{
            const newPermissions = (0, $e2f95f239ab54f09$export$7fe0bfa353103198)(permissions);
            const oldPermissions = getState().permissions;
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: {
                    jira: {
                        ...oldPermissions.jira,
                        ...newPermissions.jira
                    },
                    confluence: {
                        ...oldPermissions.confluence,
                        ...newPermissions.confluence
                    },
                    loom: {
                        ...oldPermissions.loom,
                        ...newPermissions.loom
                    }
                },
                permissionsResponse: permissions
            });
        }
};
const $21a370a6c94ec1e0$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $21a370a6c94ec1e0$var$actions,
    name: 'product-permissions'
});
const $21a370a6c94ec1e0$export$933ed92af1ed5de9 = (0, $9zUhf.createHook)($21a370a6c94ec1e0$var$Store);


const $5856de27861a3f68$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionsToCheck: permissionsToCheck, options: options })=>{
    const [state, { getPermissions: getPermissions }] = (0, $21a370a6c94ec1e0$export$933ed92af1ed5de9)();
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: options?.enabled ?? true,
            permissionsToCheck: permissionsToCheck || {
                jira: [
                    'manage',
                    'write'
                ],
                confluence: [
                    'manage',
                    'write'
                ],
                loom: [
                    'manage',
                    'write'
                ]
            }
        });
    }, [
        cloudId,
        options,
        getPermissions,
        userId,
        permissionsToCheck
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};
module.exports["useProductPermissions"] = $5856de27861a3f68$export$5814f9544ee53f3b;

});

parcelRegister("exlO1", function(module, exports) {
var $e21789de7867b609$export$7d7a98f44861e6f7 = /*#__PURE__*/ function(ContainerType) {
    ContainerType["CONFLUENCE_SPACE"] = "CONFLUENCE_SPACE";
    ContainerType["JIRA_PROJECT"] = "JIRA_PROJECT";
    ContainerType["LOOM_SPACE"] = "LOOM_SPACE";
    return ContainerType;
}({});
module.exports["ContainerType"] = $e21789de7867b609$export$7d7a98f44861e6f7;

});

parcelRegister("jQbDV", function(module, exports) {
// raw data is returned from Legion API
var $24bf014d867e0790$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["ACTIVE"] = "ACTIVE";
    TeamState["DISBANDED"] = "DISBANDED";
    TeamState["PURGED"] = "PURGED";
    return TeamState;
}({});
var $24bf014d867e0790$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["OPEN"] = "OPEN";
    TeamMembershipSettings["INVITE_ONLY"] = "MEMBER_INVITE";
    TeamMembershipSettings["EXTERNAL"] = "EXTERNAL";
    TeamMembershipSettings["ORG_ADMIN_MANAGED"] = "ORG_ADMIN_MANAGED";
    return TeamMembershipSettings;
}({});
var $24bf014d867e0790$export$c698762b98da6685 = /*#__PURE__*/ function(TeamDiscoverability) {
    TeamDiscoverability["DISCOVERABLE"] = "DISCOVERABLE";
    return TeamDiscoverability;
}({});
var $24bf014d867e0790$export$e94592bde85a4d74 = /*#__PURE__*/ function(TeamRestriction) {
    TeamRestriction["ORG_MEMBERS"] = "ORG_MEMBERS";
    TeamRestriction["NO_RESTRICTION"] = "NO_RESTRICTION";
    return TeamRestriction;
}({});
var $24bf014d867e0790$export$4db108522156032a = /*#__PURE__*/ function(TeamPermission) {
    TeamPermission["FULL_WRITE"] = "FULL_WRITE";
    TeamPermission["FULL_READ"] = "FULL_READ";
    TeamPermission["NONE"] = "NONE";
    return TeamPermission;
}({});
module.exports["TeamState"] = $24bf014d867e0790$export$c5c56131401e0716;
module.exports["TeamMembershipSettings"] = $24bf014d867e0790$export$93b1c6cf9d16dce6;
module.exports["TeamDiscoverability"] = $24bf014d867e0790$export$c698762b98da6685;
module.exports["TeamRestriction"] = $24bf014d867e0790$export$e94592bde85a4d74;
module.exports["TeamPermission"] = $24bf014d867e0790$export$4db108522156032a;

});

parcelRegister("cF2M0", function(module, exports) {
const $b44b7ef446e616a8$export$17d8d8786fe5d4ac = ({ product: product, canInviteToJiraSoftware: canInviteToJiraSoftware, canInviteToConfluence: canInviteToConfluence })=>{
    const inviteProducts = [];
    if (canInviteToJiraSoftware) inviteProducts.push('jira-software');
    if ((product === 'atlas' || !product) && canInviteToConfluence) inviteProducts.push('confluence');
    return inviteProducts;
};
module.exports["getInviteProducts"] = $b44b7ef446e616a8$export$17d8d8786fe5d4ac;

});

parcelRegister("dsjDS", function(module, exports) {
const $2eb821880b834853$export$e9ebe20ff7f8ff23 = (email)=>{
    if (!email) return undefined;
    const emailParts = email.split('@');
    if (emailParts.length === 2 && emailParts[1]) return emailParts[1];
    return undefined;
};
module.exports["getUserDomain"] = $2eb821880b834853$export$e9ebe20ff7f8ff23;

});

parcelRegister("fcfcA", function(module, exports) {

var $fDXXi = parcelRequire("fDXXi");


var $iE25L = parcelRequire("iE25L");


var $8zu5m = parcelRequire("8zu5m");


var $dAQwn = parcelRequire("dAQwn");


var $6Co6F = parcelRequire("6Co6F");





var $fAdjB = parcelRequire("fAdjB");








var $1UbNf = parcelRequire("1UbNf");

// Copied from platform/packages/people-and-teams/invite-people/src/utils/index.ts
// Consider moving to a shared package on productionisaton
const $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
const $5a50b15bfd5734ea$var$DEV_ENV_HOSTNAMES = [
    'localhost',
    '127.0.0.1',
    '0.0.0.0',
    'statlas.atl-paas.net',
    'atlaskit.atlassian.com'
];
const $5a50b15bfd5734ea$var$isProd = ()=>window.location.host.includes('-dev.com') ? false : true;
const $5a50b15bfd5734ea$var$isDevEnv = ()=>$5a50b15bfd5734ea$var$DEV_ENV_HOSTNAMES.includes(window.location.hostname);
const $5a50b15bfd5734ea$export$f6c02f8ff560b96f = ()=>$5a50b15bfd5734ea$var$isDevEnv() ? $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_DEV : $5a50b15bfd5734ea$var$isProd() ? $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_PROD : $5a50b15bfd5734ea$var$RECAPTCHA_SITE_KEY_STAGING;


const $87838d91281aa10f$var$getContinueUrl = ({ originTracer: originTracer })=>{
    const origin = window.location.origin;
    // For product domains, preference sending to the origin location in order to give the user an "onboarding" experience.
    if (origin && (origin.endsWith('.jira-dev.com') || origin.endsWith('.atlassian.net'))) return originTracer.addToUrl(origin);
    return '';
};
const $87838d91281aa10f$export$77fe4ed5de1c713e = ({ products: products, source: source, originProduct: originProduct })=>{
    const { getRecaptchaToken: getRecaptchaToken, unloadRecaptchaForSite: unloadRecaptchaForSite } = (0, $fAdjB.useInvisibleRecaptcha)({
        siteKey: (0, $5a50b15bfd5734ea$export$f6c02f8ff560b96f)(),
        displayBadge: false,
        analyticsChannel: 'peopleAndTeams',
        analyticsSource: 'useInviteToProduct',
        preventUnloadRecaptchaOnCleanup: true
    });
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    return async (emails, cloudId)=>{
        try {
            // Get reCAPTCHA token
            const recaptchaToken = await getRecaptchaToken?.('invite_to_product').catch(()=>{
                // If token generation fails we want to just continue with the
                // request without a recaptcha token (the lib will fire an event)
                return undefined;
            });
            const productAris = (0, $1UbNf.getProductAris)({
                products: products,
                cloudId: cloudId
            });
            const originTracer = new (0, $6Co6F.default)({
                product: originProduct
            });
            const originAttributes = originTracer.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            const payload = {
                users: emails.map((email)=>({
                        email: email
                    })),
                continueUrl: $87838d91281aa10f$var$getContinueUrl({
                    originTracer: originTracer
                }),
                resources: productAris,
                suppressInviteEmail: false,
                roleName: 'product/member'
            };
            const result = await (0, $dAQwn.postJson)('/gateway/api/invitations/invite', payload, recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : undefined);
            // Manually unload recaptcha. Could not rely on built in cleanup on unmount since it was happening too early and causing token not to be generated
            unloadRecaptchaForSite?.();
            const invites = result.filter((item)=>item.results && (Object.values(item.results).includes('INVITED') || Object.values(item.results).includes('INVITED_PENDING_APPROVAL')));
            invites.forEach((invite)=>{
                if (invite.id) // @ts-expect-error - we should never dynamically set the actionSubjectId
                fireEvent(`track.user.invited.${invite.id}`, {
                    integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
                    products: products,
                    inviteResult: invite.results || {},
                    inviteErrorReasons: invite.errorReasons || {},
                    ...originAttributes
                });
            });
            const errors = result.filter((item)=>item.errorReasons && Object.keys(item.errorReasons).length > 0);
            if (errors.length > 0) fireEvent('track.inviteToProductService.failed', {
                integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
                message: 'Errors occurred with inviting users',
                errorsCount: errors.length,
                errors: errors,
                result: result
            });
            return result;
        } catch (error) {
            const errorMessage = 'Failed to invite users';
            const typeGuardedError = error instanceof Error ? error : new Error(errorMessage);
            fireEvent('track.inviteToProductService.failed', {
                integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
                message: typeGuardedError.message,
                errorsCount: null,
                errors: null,
                result: null
            });
        }
    };
};


const $a6c5b6caec115345$var$addToTeam = async ({ members: members, orgId: orgId, teamId: teamId, source: source, fireEvent: fireEvent })=>{
    try {
        if (members.length === 0) return;
        const url = `/gateway/api/public/teams/v1/org/${orgId}/teams/${teamId}/members/add`;
        const data = await (0, $dAQwn.postJson)(url, {
            members: members
        });
        if (data?.members.length > 0) fireEvent('track.invitedTeamMembers.added', {
            numberOfMembers: data.members.length,
            members: data.members,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG
        });
        if (data.errors.length > 0) fireEvent('track.addToTeamService.failed', {
            errorsCount: data.errors.length,
            errors: data.errors,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
            message: null
        });
    } catch (error) {
        const typeGuardedError = error instanceof Error ? error : new Error('Failed to add users to team');
        fireEvent('track.addToTeamService.failed', {
            message: typeGuardedError.message,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG,
            errorsCount: null,
            errors: null
        });
    }
};
const $a6c5b6caec115345$export$4c14c870b6415a98 = ({ products: products, source: source, originProduct: originProduct })=>{
    const inviteToProduct = (0, $87838d91281aa10f$export$77fe4ed5de1c713e)({
        products: products,
        source: source,
        originProduct: originProduct
    });
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    return async ({ newUsersWhoNeedInvite: newUsersWhoNeedInvite, cloudId: cloudId, teamId: teamId, orgId: orgId })=>{
        try {
            if (newUsersWhoNeedInvite.length === 0) return;
            const newUsersEmails = newUsersWhoNeedInvite.map((selectedMember)=>selectedMember.id);
            const inviteToProductResult = await inviteToProduct(newUsersEmails, cloudId);
            if (!inviteToProductResult || !orgId) return;
            return new Promise((resolve)=>{
                // There is a permission sync which occurs for new invitees. The timeout is to increase chances of success for the add to team
                setTimeout(async ()=>{
                    try {
                        const members = [];
                        inviteToProductResult.forEach((invitee)=>{
                            if (invitee.id) members.push({
                                accountId: invitee.id
                            });
                        });
                        await $a6c5b6caec115345$var$addToTeam({
                            members: members,
                            orgId: orgId,
                            teamId: teamId,
                            source: source,
                            fireEvent: fireEvent
                        });
                    } catch (error) {
                        (0, $iE25L.logException)(error, 'addToTeamError');
                    } finally{
                        resolve();
                    }
                }, 6000);
            });
        } catch (error) {
            (0, $iE25L.logException)(error, 'useInviteAndAddToTeamError');
        }
    };
};
module.exports["useInviteAndAddToTeam"] = $a6c5b6caec115345$export$4c14c870b6415a98;

});

parcelRegister("8zu5m", function(module, exports) {
var $fe09d2d8b6a84765$export$4bce2c1f3a5d9f61 = /*#__PURE__*/ function(AnalyticsActionSubject) {
    AnalyticsActionSubject["ERROR_BOUNDARY"] = "errorBoundary";
    AnalyticsActionSubject["MEMBER_PICKER"] = "memberPicker";
    AnalyticsActionSubject["TEAM_TYPE_PICKER"] = "teamTypePicker";
    AnalyticsActionSubject["TEAM_CREATE_DIALOG"] = "teamCreateDialog";
    AnalyticsActionSubject["DROP_DOWN_MENU"] = "dropdownMenu";
    AnalyticsActionSubject["ADD_TO_TEAM_SERVICE"] = "addToTeamService";
    AnalyticsActionSubject["INVITE_TO_PRODUCT_SERVICE"] = "inviteToProductService";
    AnalyticsActionSubject["INVITE_CAPABILITIES_SERVICE"] = "inviteCapabilitiesService";
    AnalyticsActionSubject["INVITED_TEAM_MEMBERS"] = "invitedTeamMembers";
    AnalyticsActionSubject["USER"] = "user";
    AnalyticsActionSubject["REQUESTED_CONTAINERS"] = "requestedContainers";
    AnalyticsActionSubject["CONTAINER_PERMISSIONS"] = "containerPermissions";
    AnalyticsActionSubject["MEMBER"] = "member";
    return AnalyticsActionSubject;
}({});
var $fe09d2d8b6a84765$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["ERROR"] = "error";
    AnalyticsAction["SUBMITED"] = "submitted";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["INVITED"] = "invited";
    AnalyticsAction["REQUESTED"] = "requested";
    AnalyticsAction["ADDED"] = "added";
    AnalyticsAction["SUGGESTED"] = "suggested";
    return AnalyticsAction;
}({});
var $fe09d2d8b6a84765$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["PEOPLE_TEAMS"] = "peopleTeams";
    return AnalyticsSource;
}({});
module.exports["AnalyticsActionSubject"] = $fe09d2d8b6a84765$export$4bce2c1f3a5d9f61;
module.exports["AnalyticsSource"] = $fe09d2d8b6a84765$export$6890652a1aff7d1c;

});

parcelRegister("dAQwn", function(module, exports) {
const $49909d5d95652733$export$83179404a61b001a = 'FetchError';
function $49909d5d95652733$export$847691ec04985fa0(error, status, traceId) {
    return {
        name: $49909d5d95652733$export$83179404a61b001a,
        message: error.message,
        stack: error.stack,
        status: status,
        traceId: traceId
    };
}
const $49909d5d95652733$export$6d71b655afe1638d = (url, init)=>{
    return fetch(url, {
        credentials: 'include',
        ...init
    }).then((response)=>{
        if (response.ok) return response.json();
        const traceId = response?.headers?.get('atl-traceid') || undefined;
        throw $49909d5d95652733$export$847691ec04985fa0(new Error(`Unable to fetch ${url} ${response.status} ${response.statusText}`), response.status, traceId);
    });
};
const $49909d5d95652733$export$c776284ef4b1209a = (url, data, headers)=>$49909d5d95652733$export$6d71b655afe1638d(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        body: JSON.stringify(data)
    });
module.exports["fetchJson"] = $49909d5d95652733$export$6d71b655afe1638d;
module.exports["postJson"] = $49909d5d95652733$export$c776284ef4b1209a;

});

parcelRegister("bte6P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $iE25L = parcelRequire("iE25L");


var $hYSRS = parcelRequire("hYSRS");


var $8zu5m = parcelRequire("8zu5m");


var $dAQwn = parcelRequire("dAQwn");


var $1UbNf = parcelRequire("1UbNf");

const $fa9707026b041c7c$var$fetchInviteCapabilities = async ({ products: products, cloudId: cloudId, source: source, fireEvent: fireEvent })=>{
    try {
        const productARIs = (0, $1UbNf.getProductAris)({
            products: products,
            cloudId: cloudId
        });
        const payload = {
            productARIs: productARIs
        };
        const result = await (0, $dAQwn.postJson)('/gateway/api/v3/invitations/capabilities', payload);
        return result;
    } catch (e) {
        fireEvent('operational.inviteCapabilitiesService.failed', {
            products: products,
            integration: source || (0, $8zu5m.AnalyticsActionSubject).TEAM_CREATE_DIALOG
        });
        return undefined;
    }
};
const $fa9707026b041c7c$export$67376debdcebd5d2 = ({ product: product, response: response })=>{
    if (!response) return false;
    const productResponseItem = response.find((responseItem)=>responseItem.resourceARI?.includes(product));
    if (!productResponseItem) return false;
    if (productResponseItem.directInvite?.mode === 'ANYONE' || productResponseItem.directInvite?.mode === 'DOMAIN_RESTRICTED') return true;
    return false;
};
const $fa9707026b041c7c$export$e3ce16335d404d03 = ({ cloudId: cloudId, shouldRun: shouldRun, source: source })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    const [data, setData] = (0, $42omo.useState)(undefined);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $hYSRS.useOnceWhen)(!isLoading && !data && shouldRun, async ()=>{
        setIsLoading(true);
        try {
            const result = await $fa9707026b041c7c$var$fetchInviteCapabilities({
                products: [
                    'jira-software',
                    'confluence'
                ],
                cloudId: cloudId,
                source: source,
                fireEvent: fireEvent
            });
            setIsLoading(false);
            setData(result);
        } catch (error) {
            (0, $iE25L.logException)(error, 'useInviteCapabilitiesError');
        } finally{
            setIsLoading(false);
        }
    });
    return {
        isLoading: isLoading,
        data: data,
        canInviteToJiraSoftware: $fa9707026b041c7c$export$67376debdcebd5d2({
            product: 'jira-software',
            response: data
        }),
        canInviteToConfluence: $fa9707026b041c7c$export$67376debdcebd5d2({
            product: 'confluence',
            response: data
        })
    };
};
module.exports["useInviteCapabilities"] = $fa9707026b041c7c$export$e3ce16335d404d03;

});

parcelRegister("hYSRS", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $c7e560c947f43c7d$export$602521d848dcbc8f = (fn, deps = [])=>{
    const called = (0, $42omo.useRef)(false);
    return (0, $42omo.useCallback)(()=>{
        if (!called.current) {
            called.current = true;
            fn();
        }
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
const $c7e560c947f43c7d$export$4ff988088e6353d2 = (condition, fn, deps)=>{
    const fire = $c7e560c947f43c7d$export$602521d848dcbc8f(fn, deps);
    (0, $42omo.useEffect)(()=>{
        if (condition) fire();
    }, [
        condition,
        fire
    ]);
};
module.exports["useOnceWhen"] = $c7e560c947f43c7d$export$4ff988088e6353d2;

});

parcelRegister("3PCpU", function(module, exports) {
class $1e07f84512b90a64$export$6e749dfbce027249 extends Error {
    constructor(message, context){
        super(message);
        this.context = void 0;
        this.context = context;
    }
}
module.exports["ErrorWithContext"] = $1e07f84512b90a64$export$6e749dfbce027249;

});

parcelRegister("cpl2G", function(module, exports) {
const $a9507de806b2aaad$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $a9507de806b2aaad$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $a9507de806b2aaad$var$fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $a9507de806b2aaad$var$runItLater(()=>{
            createAnalyticsEvent({
                eventType: kind,
                ...body
            }).fire($a9507de806b2aaad$var$ANALYTICS_CHANNEL);
        });
    };
const $a9507de806b2aaad$export$a1fb57756f0de62b = $a9507de806b2aaad$var$fireEvent('operational');
const $a9507de806b2aaad$export$59608e0169622110 = $a9507de806b2aaad$var$fireEvent('screen');
const $a9507de806b2aaad$export$574d2f19a52d67ca = $a9507de806b2aaad$var$fireEvent('track');
const $a9507de806b2aaad$export$7eca133280843f9e = $a9507de806b2aaad$var$fireEvent('ui');
const $a9507de806b2aaad$export$91c413c8a5c77e19 = (error)=>{
    if (!error) return false;
    // Check for ' 403' with space beforehand to not count urls containing 403 in cloud or team id
    if ('status' in error && error['status'] === 403 || error?.message?.includes(' 403')) return false;
    if ('status' in error && error['status'] === 401 || error?.message?.includes(' 401')) return false;
    if ('status' in error && error['status'] === 429 || error?.message?.includes(' 429')) return false;
    if (error.message === 'Failed to fetch') return false;
    return true;
};
module.exports["fireOperationalEvent"] = $a9507de806b2aaad$export$a1fb57756f0de62b;
module.exports["isSeriousError"] = $a9507de806b2aaad$export$91c413c8a5c77e19;

});

parcelRegister("iMEBP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $8C5kA = parcelRequire("8C5kA");

const $c185de2fb66b56b0$export$94d2d72df36bbb16 = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'es-ES',
    'et-EE',
    'fi-FI',
    'fr-FR',
    'hu-HU',
    'is-IS',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NB',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sv-SE',
    'tr-TR',
    'th-TH',
    'uk-UK',
    'vi-VI',
    'zh-TW',
    'zh-HK',
    'zh-ZH',
    'zh-CN'
];
const $c185de2fb66b56b0$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};
function $c185de2fb66b56b0$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $42omo.useState)({});
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = $c185de2fb66b56b0$export$4d25b49b6dc1b540(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const module = await fetchLanguageFile(finalLocale);
                const newMessages = module.default || module;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        locale,
        fetchLanguageFile
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $c185de2fb66b56b0$export$b4f1ecc6daf5eb10 = (props)=>{
    const { children: children, fetchLanguageFile: fetchLanguageFile, ...rest } = props;
    const { locale: locale, messages: allMessages = {} } = (0, $8C5kA.default)();
    const { messages: messages } = $c185de2fb66b56b0$export$5ac26fa9b941854e(locale, fetchLanguageFile);
    // Product might have already provided messages.
    // In the server-side environment, useFetchMessagesByLocale is noop we are relying on product to provide messages.
    for(const key in messages)if (!allMessages[key]) allMessages[key] = messages[key];
    return /*#__PURE__*/ (0, $42omo.createElement)((0, $1e2E5.default), {
        ...rest,
        messages: allMessages,
        key: locale,
        locale: locale,
        defaultLocale: "en-US"
    }, children);
};
module.exports["LazyIntlProvider"] = $c185de2fb66b56b0$export$b4f1ecc6daf5eb10;

});

parcelRegister("erMpQ", function(module, exports) {
function $6add25e4d38bca26$var$toStrParams(obj) {
    const str = Object.keys(obj).map((k)=>{
        const v = obj[k];
        return v ? `${k}=${encodeURIComponent(v)}` : undefined;
    }).filter((it)=>!!it).join('&');
    return str ? `?${str}` : '';
}
function $6add25e4d38bca26$export$d479c7e8f449d360(originQuery) {
    return $6add25e4d38bca26$var$toStrParams({
        'origin.cloudId': originQuery.cloudId,
        'origin.product': originQuery.product?.toUpperCase() || ''
    });
}
function $6add25e4d38bca26$export$575daf737e125483(remoteConfigResources) {
    return remoteConfigResources?.baseUrl || '';
}
function $6add25e4d38bca26$export$873f5b458fb2c7bd({ remoteConfigResources: remoteConfigResources, orgId: orgId, ref: ref, src: src }) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleDirectoryHome || '').replace(':orgId', orgId ?? '')}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$a8c794e14e33c8e9(remoteConfigResources, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${remoteConfigResources?.peopleDirectoryHome || ''}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$8d1c08ae3a193cc5(remoteConfigResources, userId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.peopleProfile || '').replace(':userId', userId)}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$143be302a1686103({ remoteConfigResources: remoteConfigResources, teamId: teamId, orgId: orgId, ref: ref, src: src, containers: containers }) {
    const params = {
        ref: ref,
        src: src,
        requestedContainers: containers && containers.length > 0 ? containers.join(',') : undefined
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId).replace(':orgId', orgId ?? '')}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$8b8a898467a65284(remoteConfigResources, teamId, ref, src) {
    const params = {
        ref: ref,
        src: src
    };
    return `${$6add25e4d38bca26$export$575daf737e125483(remoteConfigResources)}${(remoteConfigResources?.teamProfile || '').replace(':teamId', teamId)}${$6add25e4d38bca26$var$toStrParams(params)}`;
}
function $6add25e4d38bca26$export$41ba1f3da3359c4(url = '') {
    if (url[url.length - 1] === '/') return url.slice(0, -1);
    return url;
}
module.exports["constructProductOriginParams"] = $6add25e4d38bca26$export$d479c7e8f449d360;
module.exports["getPeopleDirectoryHomePageWithOrgId"] = $6add25e4d38bca26$export$873f5b458fb2c7bd;
module.exports["getPeopleProfilePage"] = $6add25e4d38bca26$export$8d1c08ae3a193cc5;
module.exports["getTeamProfilePageLinkWithOrgId"] = $6add25e4d38bca26$export$143be302a1686103;
module.exports["trimLastForwardSlash"] = $6add25e4d38bca26$export$41ba1f3da3359c4;

});

parcelRegister("dVp1j", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $b40a61fbc9ba9d75$export$f138d6bfac6fdfd5 = new (0, $5aVN7.UFOExperience)('team-creation-action', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});


const $ba9e625f89ca50bb$export$7e9cc5548016e4d1 = ()=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const triggerAnalyticsForCreateTeamSuccess = (0, $42omo.useCallback)((attributes)=>{
        // @ts-expect-error - operational.teamCreateDialog.succeeded can not be defined in the analytics spec as it is a duplicate event
        fireEvent('operational.teamCreateDialog.succeeded', attributes);
        (0, $b40a61fbc9ba9d75$export$f138d6bfac6fdfd5).success({
            metadata: {
                ...attributes,
                defaultTeamType: attributes.defaultTeamType ?? undefined,
                teamTypeChoiceEnabled: attributes.teamTypeChoiceEnabled === null ? undefined : attributes.teamTypeChoiceEnabled
            }
        });
        fireEvent('track.teamCreateDialog.succeeded', attributes);
    }, [
        fireEvent
    ]);
    const triggerAnalyticsForCreateTeamFailed = (0, $42omo.useCallback)((attributes)=>{
        // @ts-expect-error - operational.teamCreateDialog.failed can not be defined in the analytics spec as it is a duplicate event
        fireEvent('operational.teamCreateDialog.failed', attributes);
        (0, $b40a61fbc9ba9d75$export$f138d6bfac6fdfd5).failure({
            metadata: {
                ...attributes,
                errorStack: attributes.errorStack ?? undefined,
                traceId: attributes.traceId ?? undefined
            }
        });
        fireEvent('track.teamCreateDialog.failed', attributes);
    }, [
        fireEvent
    ]);
    const triggerAnalyticsForSubmitTeamCreateDialog = (0, $42omo.useCallback)((attributes)=>{
        fireEvent('ui.teamCreateDialog.submitted', attributes);
        (0, $b40a61fbc9ba9d75$export$f138d6bfac6fdfd5).start();
    }, [
        fireEvent
    ]);
    return {
        triggerAnalyticsForCreateTeamSuccess: triggerAnalyticsForCreateTeamSuccess,
        triggerAnalyticsForCreateTeamFailed: triggerAnalyticsForCreateTeamFailed,
        triggerAnalyticsForSubmitTeamCreateDialog: triggerAnalyticsForSubmitTeamCreateDialog
    };
};
var $ba9e625f89ca50bb$export$2e2bcd8739ae039 = $ba9e625f89ca50bb$export$7e9cc5548016e4d1;
module.exports["default"] = $ba9e625f89ca50bb$export$2e2bcd8739ae039;

});

parcelRegister("dTRYM", function(module, exports) {
const $4f385fb34c505736$export$a8a815044211bb75 = 50;
const $4f385fb34c505736$export$a954cbc46095ce6a = 150;
const $4f385fb34c505736$export$7e6ba5d480e9bd2f = ()=>undefined;
module.exports["MAX_MEMBERS"] = $4f385fb34c505736$export$a8a815044211bb75;
module.exports["DEBOUNCE_MS"] = $4f385fb34c505736$export$a954cbc46095ce6a;
module.exports["VOID_FUNC"] = $4f385fb34c505736$export$7e6ba5d480e9bd2f;

});

parcelRegister("7sG51", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4732c4756b984d71$var$PREFIX = 'ptc.pt';
const $4732c4756b984d71$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    // member pickers
    limitedUsersInvitationMessageInfo: {
        id: "ptc.pt.member-picker.msg.exceed.limited.number.info",
        defaultMessage: "You can invite up to {maxNumber, plural,       one {1 person}       other {{maxNumber} people}} at once."
    },
    limitedUsersInvitationMessageError: {
        id: "ptc.pt.member-picker.error.msg.exceed.limited.number.error2",
        defaultMessage: "You've entered more than {maxNumber, plural,       one {{maxNumber} person}       other {{maxNumber} people}}."
    },
    limitedUsersInvitationMessageMaximumError: {
        id: "ptc.pt.member-picker.error.msg.reach.limited.number.error",
        defaultMessage: "You can only invite up to {maxNumber, plural,       one {{maxNumber} person}       other {{maxNumber} people}} at once."
    },
    userPickerPlaceholder: {
        id: "ptc.pt.member-picker.placeholder",
        defaultMessage: "Choose people"
    },
    userPickerPlaceholderNext: {
        id: "ptc.pt.member-picker.placeholder.next",
        defaultMessage: "Search for team members"
    },
    userPickerNoOption: {
        id: "ptc.pt.member-picker.no-option",
        defaultMessage: "No matches."
    },
    userPickerNoOptionWithEmailSuggestion: {
        id: "ptc.pt.member-picker.no-option-with-email-suggestion",
        defaultMessage: "Enter an email address"
    },
    enterMore: {
        id: "ptc.pt.member-picker.enter-more",
        defaultMessage: "Enter more"
    },
    // team-create-dialog
    modalTitle: {
        id: "ptc.pt.team-create-dialog.title",
        defaultMessage: "Create a team"
    },
    modalTitleNext: {
        id: "ptc.pt.team-create-dialog.title.next",
        defaultMessage: "Create team"
    },
    modalTitleIconLabel: {
        id: "ptc.pt.team-create-dialog.title",
        defaultMessage: "Teams icon"
    },
    formTextWithMention: {
        id: "ptc.pt.team-create-dialog.pretext.with.mention",
        defaultMessage: "Bring everyone together with one team you can @mention, filter, and assign work to. {learnMoreLink}"
    },
    requiredFieldSummary: {
        id: "ptc.pt.team-create-dialog.required-field.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    teamNameFieldLabel: {
        id: "ptc.pt.team-create-dialog.team-name-field.label",
        defaultMessage: "Team name"
    },
    teamNameFieldLabelNext: {
        id: "ptc.pt.team-create-dialog.team-name-field.label.next",
        defaultMessage: "Name"
    },
    teamNameFieldPlaceholder: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.placeholder",
        defaultMessage: "e.g. HR Team, Redesign Project, Team Mango"
    },
    teamNameFieldRequiredErrorMessage: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.required.error-message",
        defaultMessage: "You must provide a team name"
    },
    teamNameFieldTooLongErrorMessage: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.too-long.error-message",
        defaultMessage: "Team name must be 100 characters or less"
    },
    teamNameFieldInfoMessage: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.info-message",
        defaultMessage: "Who can see your team name?"
    },
    teamNameFieldInfoDetail: {
        id: "ptc.pt.team-create-dialog.modal.team-name-field.info-detail",
        defaultMessage: "Your team name is visible to anyone in your organisation. It may be visible on work shared outside your organisation."
    },
    submitButtonLabel: {
        id: "ptc.pt.team-create-dialog.button.submit",
        defaultMessage: "Create a team"
    },
    submitButtonLabelNext: {
        id: "ptc.pt.team-create-dialog.button.submit.next",
        defaultMessage: "Create"
    },
    cancelButtonLabel: {
        id: "ptc.pt.team-create-dialog.button.cancel",
        defaultMessage: "Cancel"
    },
    learnMore: {
        id: "ptc.pt.team-create-dialog.learn-more",
        defaultMessage: "What\u2019s a team?"
    },
    backButton: {
        id: "ptc.pt.team-create-dialog.button.back",
        defaultMessage: "Go back"
    },
    // flags of team-create-dialog
    flagSuccessCreateTeamTitle: {
        id: "ptc.pt.team-create-dialog.flag-success.title",
        defaultMessage: "Team has been created"
    },
    flagSuccessCreateTeamDesc: {
        id: "ptc.pt.team-create-dialog.flag-success.desc",
        defaultMessage: "Start collaborating by @mentioning the team\u2019s name, or view the team\u2019s profile."
    },
    flagSuccessCreateTeamAction: {
        id: "ptc.pt.team-create-dialog.flag-success.action",
        defaultMessage: "View team"
    },
    flagErrorCreateTeamTitle: {
        id: "ptc.pt.team-create-dialog.flag-error.title",
        defaultMessage: "Sorry, something went wrong"
    },
    flagErrorCreateTeamDesc: {
        id: "ptc.pt.team-create-dialog.flag-error.desc",
        defaultMessage: "We couldn't save your team. Please try again."
    },
    flagErrorCreateTeamPartialFailTitle: {
        id: "ptc.pt.team-create-dialog.flag-partial-error.title",
        defaultMessage: "Sorry, something went wrong"
    },
    flagErrorCreateTeamPartialFailDesc: {
        id: "ptc.pt.team-create-dialog.flag-partial-error.desc",
        defaultMessage: "We couldn't invite some members. Please try again."
    },
    // inviting members
    invitationsFieldLabel: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.label",
        defaultMessage: "Who should be in this team?"
    },
    invitationsFieldLabelNext: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.label.next",
        defaultMessage: "Add team members"
    },
    invitationsFieldErrorMessage: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.error-message",
        defaultMessage: "Teams must contain at least one member. You can invite up to {maxSelectedMembers, plural, one {# person} other {# people}} at a time."
    },
    invitationsFieldErrorMessageNext: {
        id: "ptc.pt.team-create-dialog.modal.fields.invite-emails.error-message.next",
        defaultMessage: "You must add at least one team member"
    },
    // team membership control
    teamTypePickerLabel: {
        id: "ptc.pt.team-type-picker.field.label",
        defaultMessage: "Membership controls"
    },
    new: {
        id: "ptc.pt.team-type-picker.field.new.lozenge",
        defaultMessage: "New"
    },
    teamTypeCheckboxLabel: {
        id: "ptc.pt.team-type-picker.checkbox.label",
        defaultMessage: "Anyone can join this team without approval"
    },
    openTeam: {
        id: "ptc.pt.team-type-picker.team-type.open",
        defaultMessage: "Open team"
    },
    inviteOnlyTeam: {
        id: "ptc.pt.team-type-picker.team-type.invite-only",
        defaultMessage: "Invite-only team"
    },
    openTeamDescription: {
        id: "ptc.pt.team-type-picker.team-type.open.description",
        defaultMessage: "Anyone in your organisation can join and edit the team."
    },
    inviteOnlyTeamDescription: {
        id: "ptc.pt.team-type-picker.team-type.invite-only.description",
        defaultMessage: "Anyone in your organisation can request to join and must be approved by a current team member."
    },
    noAccessErrorStateTitle: {
        id: "ptc.pt.team-create-dialog.no-access-error.title",
        defaultMessage: "We can't create your team"
    },
    noAccessErrorStateMessage: {
        id: "ptc.pt.team-create-dialog.no-access-error.description",
        defaultMessage: "You don't have access to create teams in this organization."
    },
    noAccessErrorStateActionLabel: {
        id: "ptc.pt.team-create-dialog.no-access-error.action-label",
        defaultMessage: "OK"
    },
    teamProductAccessFlagInformInviteToProductsTitle: {
        id: "ptc.pt.team-create-dialog.experiment-flag-invite-to-products-informing.title",
        defaultMessage: "App access requested"
    },
    teamProductAccessFlagInformInviteToProductsDesc: {
        id: "ptc.pt.team-create-dialog.experiment-flag-invite-to-products-informing.desc",
        defaultMessage: "All members should receive an email confirming their access to selected products. {br}If you're not an admin, your product requests may be sent to one for approval."
    },
    // create containers
    createContainersLabel: {
        id: "ptc.pt.team-create-dialog.create-containers.label",
        defaultMessage: "Add new team spaces"
    },
    createContainersInfo: {
        id: "ptc.pt.team-create-dialog.create-containers.info",
        defaultMessage: "Spaces will be made matching this team\u2019s name and will be automatically linked."
    },
    createContainersJira: {
        id: "ptc.pt.team-create-dialog.create-containers.jira",
        defaultMessage: "Jira project"
    },
    createContainersConfluence: {
        id: "ptc.pt.team-create-dialog.create-containers.confluence",
        defaultMessage: "Confluence space"
    },
    createContainersLoom: {
        id: "ptc.pt.team-create-dialog.create-containers.loom",
        defaultMessage: "Loom space"
    },
    skeletonItemLoading: {
        id: "ptc.pt.skeleton-item.loading",
        defaultMessage: "Menu item is loading"
    },
    recommendedUsersTitle: {
        id: "ptc.pt.team-create-dialog.recommended-users.title-next",
        defaultMessage: "Recommended users"
    },
    teamTypeSelectLabel: {
        id: "ptc.pt.team-type-select.label",
        defaultMessage: "Type"
    },
    teamOpenMembershipDisclaimer: {
        id: "ptc.pt.team-type-picker.team-open-membership.disclaimer",
        defaultMessage: "Anyone that joins can also add or remove any members and change the team details. <a>Read more</a>"
    }
});
module.exports["messages"] = $4732c4756b984d71$export$defe85febe8b728c;

});

parcelRegister("kLwto", function(module, exports) {
/* istanbul ignore file */ const $dc3dab64e37c56d9$export$bcd1dd1f397bba12 = ()=>Promise.resolve({
        default: {}
    });

const $dc3dab64e37c56d9$export$bde1ed0f60b38f2f = ()=>(parcelRequire("3lZRK"));

const $dc3dab64e37c56d9$export$8c8450b83b664ba4 = ()=>(parcelRequire("7mqs9"));

const $dc3dab64e37c56d9$export$2fa162a495d26869 = ()=>(parcelRequire("9QXth"));

const $dc3dab64e37c56d9$export$84584c2a98eb6753 = ()=>(parcelRequire("gwBdZ"));

const $dc3dab64e37c56d9$export$141cd05f569bae45 = ()=>(parcelRequire("4gfKl"));

const $dc3dab64e37c56d9$export$a3f288d6c3177b8a = ()=>(parcelRequire("5Jjgo"));

const $dc3dab64e37c56d9$export$ca5e4045a55e76d2 = ()=>(parcelRequire("d6SYh"));

const $dc3dab64e37c56d9$export$457177dcde8472be = ()=>(parcelRequire("3oCoP"));

const $dc3dab64e37c56d9$export$ed5179c818622fb = ()=>(parcelRequire("iWlgX"));

const $dc3dab64e37c56d9$export$acb2a88f7d552ebf = ()=>(parcelRequire("bt9tU"));

const $dc3dab64e37c56d9$export$9901d21957972d53 = ()=>(parcelRequire("7iYB2"));

const $dc3dab64e37c56d9$export$226b3eccf92c9ed9 = ()=>(parcelRequire("7XDBL"));

const $dc3dab64e37c56d9$export$3486a10f30cf1ee4 = ()=>(parcelRequire("2qcAk"));

const $dc3dab64e37c56d9$export$8c6f505e9474ce90 = ()=>(parcelRequire("iAkHQ"));

const $dc3dab64e37c56d9$export$798cf677954c9533 = ()=>(parcelRequire("7fKvu"));

const $dc3dab64e37c56d9$export$38ef0e3f791a121e = ()=>(parcelRequire("QhOo0"));

const $dc3dab64e37c56d9$export$9c64ee4d84d79ce1 = ()=>(parcelRequire("ax0PZ"));

const $dc3dab64e37c56d9$export$6ea5311eda92944f = ()=>(parcelRequire("79QiG"));

const $dc3dab64e37c56d9$export$84175d5f1cb4e39d = ()=>(parcelRequire("fCW89"));

const $dc3dab64e37c56d9$export$82924b14976e7373 = ()=>(parcelRequire("6ytYa"));

const $dc3dab64e37c56d9$export$ea30ec7f37fb148d = ()=>(parcelRequire("d21At"));

const $dc3dab64e37c56d9$export$cf48009033a0126b = ()=>(parcelRequire("86pAZ"));

const $dc3dab64e37c56d9$export$d608fa5b5bfd2021 = ()=>(parcelRequire("fBNxQ"));

const $dc3dab64e37c56d9$export$65540e5f7f6e7dce = ()=>(parcelRequire("e9b8w"));

const $dc3dab64e37c56d9$export$72451b88a72ad9c2 = ()=>(parcelRequire("jRB0q"));

const $dc3dab64e37c56d9$export$d657bc098992a431 = ()=>(parcelRequire("8DFjK"));

const $dc3dab64e37c56d9$export$312745a8a3013c00 = ()=>(parcelRequire("7iUnH"));

const $dc3dab64e37c56d9$export$e3786bf10a8abdf2 = ()=>(parcelRequire("5hoEo"));

const $dc3dab64e37c56d9$export$b65a7f08f2280505 = ()=>(parcelRequire("h5TZH"));

const $dc3dab64e37c56d9$export$41779e6acd26e15f = ()=>(parcelRequire("eKtdF"));


function $1406cfc18ea56582$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return $dc3dab64e37c56d9$export$bde1ed0f60b38f2f();
        case 'da-DK':
        case 'da':
            return $dc3dab64e37c56d9$export$8c8450b83b664ba4();
        case 'de-DE':
        case 'de':
            return $dc3dab64e37c56d9$export$2fa162a495d26869();
        case 'en-GB':
            return $dc3dab64e37c56d9$export$141cd05f569bae45();
        case 'en-US':
        case 'en':
            return $dc3dab64e37c56d9$export$84584c2a98eb6753();
        case 'en-ZZ':
            return $dc3dab64e37c56d9$export$a3f288d6c3177b8a();
        case 'es-ES':
        case 'es':
            return $dc3dab64e37c56d9$export$ca5e4045a55e76d2();
        case 'et-EE':
        case 'et':
            return $dc3dab64e37c56d9$export$457177dcde8472be();
        case 'fi-FI':
        case 'fi':
            return $dc3dab64e37c56d9$export$ed5179c818622fb();
        case 'fr-FR':
        case 'fr':
            return $dc3dab64e37c56d9$export$acb2a88f7d552ebf();
        case 'hu-HU':
        case 'hu':
            return $dc3dab64e37c56d9$export$9901d21957972d53();
        case 'is-IS':
        case 'is':
            return $dc3dab64e37c56d9$export$226b3eccf92c9ed9();
        case 'it-IT':
        case 'it':
            return $dc3dab64e37c56d9$export$3486a10f30cf1ee4();
        case 'ja-JP':
        case 'ja':
            return $dc3dab64e37c56d9$export$8c6f505e9474ce90();
        case 'ko-KR':
        case 'ko':
            return $dc3dab64e37c56d9$export$798cf677954c9533();
        case 'nb-NB':
        case 'nb':
            return $dc3dab64e37c56d9$export$38ef0e3f791a121e();
        case 'nl-NL':
        case 'nl':
            return $dc3dab64e37c56d9$export$9c64ee4d84d79ce1();
        case 'pl-PL':
        case 'pl':
            return $dc3dab64e37c56d9$export$6ea5311eda92944f();
        case 'pt-BR':
        case 'pt_BR':
            return $dc3dab64e37c56d9$export$82924b14976e7373();
        case 'pt-PT':
        case 'pt_PT':
        case 'pt':
            return $dc3dab64e37c56d9$export$84175d5f1cb4e39d();
        case 'ro-RO':
        case 'ro':
            return $dc3dab64e37c56d9$export$ea30ec7f37fb148d();
        case 'ru-RU':
        case 'ru':
            return $dc3dab64e37c56d9$export$cf48009033a0126b();
        case 'sk-SK':
        case 'sk':
            return $dc3dab64e37c56d9$export$d608fa5b5bfd2021();
        case 'sv-SE':
        case 'sv':
            return $dc3dab64e37c56d9$export$65540e5f7f6e7dce();
        case 'tr-TR':
        case 'tr':
            return $dc3dab64e37c56d9$export$72451b88a72ad9c2();
        case 'th-TH':
        case 'th':
            return $dc3dab64e37c56d9$export$d657bc098992a431();
        case 'uk-UK':
        case 'uk':
            return $dc3dab64e37c56d9$export$312745a8a3013c00();
        case 'vi-VI':
        case 'vi':
            return $dc3dab64e37c56d9$export$e3786bf10a8abdf2();
        case 'zh-TW':
        case 'zh-HK':
            return $dc3dab64e37c56d9$export$41779e6acd26e15f();
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return $dc3dab64e37c56d9$export$b65a7f08f2280505();
    }
    return $dc3dab64e37c56d9$export$bcd1dd1f397bba12();
}
module.exports["fetchLanguageFile"] = $1406cfc18ea56582$export$c08b58fa4727b0d2;

});

parcelRegister("3lZRK", function(module, exports) {

let $2713528b3831c9f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2713528b3831c9f6$var$load("48eS0").then(()=>parcelRequire('ypOne'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("7mqs9", function(module, exports) {

let $55bf1b7f686c086e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $55bf1b7f686c086e$var$load("lak6L").then(()=>parcelRequire('b3xxh'));

});

parcelRegister("9QXth", function(module, exports) {

let $72c71a29467c0ffb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $72c71a29467c0ffb$var$load("inCHL").then(()=>parcelRequire('8KrTk'));

});

parcelRegister("gwBdZ", function(module, exports) {

let $c07c8285b27c853e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c07c8285b27c853e$var$load("lLx4a").then(()=>parcelRequire('2JrnR'));

});

parcelRegister("4gfKl", function(module, exports) {

let $31a4def8cb892837$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31a4def8cb892837$var$load("auTAr").then(()=>parcelRequire('88hCk'));

});

parcelRegister("5Jjgo", function(module, exports) {

let $42c019073de7d257$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $42c019073de7d257$var$load("9pxVf").then(()=>parcelRequire('7DuAp'));

});

parcelRegister("d6SYh", function(module, exports) {

let $98b67a0f10790a1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $98b67a0f10790a1a$var$load("4cEzx").then(()=>parcelRequire('igYJ8'));

});

parcelRegister("3oCoP", function(module, exports) {

let $27916651a2909578$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $27916651a2909578$var$load("iUIL3").then(()=>parcelRequire('aIz3E'));

});

parcelRegister("iWlgX", function(module, exports) {

let $dc9e2511c533211d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dc9e2511c533211d$var$load("lADZV").then(()=>parcelRequire('l27r9'));

});

parcelRegister("bt9tU", function(module, exports) {

let $8599c1f4dcea2e37$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8599c1f4dcea2e37$var$load("1QHKh").then(()=>parcelRequire('l1BWk'));

});

parcelRegister("7iYB2", function(module, exports) {

let $551937ffa78c83a1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $551937ffa78c83a1$var$load("2Tjcq").then(()=>parcelRequire('jqujB'));

});

parcelRegister("7XDBL", function(module, exports) {

let $5cbcc474efe5950b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5cbcc474efe5950b$var$load("4WVVc").then(()=>parcelRequire('lHEzk'));

});

parcelRegister("2qcAk", function(module, exports) {

let $1c37c59193b5b826$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c37c59193b5b826$var$load("1QNch").then(()=>parcelRequire('7cv4i'));

});

parcelRegister("iAkHQ", function(module, exports) {

let $d87ba69802196301$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d87ba69802196301$var$load("jQCyA").then(()=>parcelRequire('ctrbZ'));

});

parcelRegister("7fKvu", function(module, exports) {

let $547e0265011c56a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $547e0265011c56a2$var$load("aQwae").then(()=>parcelRequire('4w9rV'));

});

parcelRegister("QhOo0", function(module, exports) {

let $09d2ac78e93fafff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $09d2ac78e93fafff$var$load("cS1j1").then(()=>parcelRequire('7MhCX'));

});

parcelRegister("ax0PZ", function(module, exports) {

let $7aada2c812f4ec72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7aada2c812f4ec72$var$load("48pzM").then(()=>parcelRequire('bgdNn'));

});

parcelRegister("79QiG", function(module, exports) {

let $5361f173491caa0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5361f173491caa0e$var$load("c4a0F").then(()=>parcelRequire('7WlOv'));

});

parcelRegister("fCW89", function(module, exports) {

let $b6077f26741f40f8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b6077f26741f40f8$var$load("cBmO4").then(()=>parcelRequire('ab9yn'));

});

parcelRegister("6ytYa", function(module, exports) {

let $4c5d2a5856125022$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4c5d2a5856125022$var$load("9e3Ob").then(()=>parcelRequire('3rV3A'));

});

parcelRegister("d21At", function(module, exports) {

let $97ccb17b6c28f40d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $97ccb17b6c28f40d$var$load("7Hoje").then(()=>parcelRequire('2lDN4'));

});

parcelRegister("86pAZ", function(module, exports) {

let $0185b8ba00cd75ac$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0185b8ba00cd75ac$var$load("4dj0m").then(()=>parcelRequire('ifesT'));

});

parcelRegister("fBNxQ", function(module, exports) {

let $b5d0be470396825e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5d0be470396825e$var$load("j5HYK").then(()=>parcelRequire('lv5RJ'));

});

parcelRegister("e9b8w", function(module, exports) {

let $a4ca8b6726837ddc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a4ca8b6726837ddc$var$load("1VsiM").then(()=>parcelRequire('aWXF5'));

});

parcelRegister("jRB0q", function(module, exports) {

let $e75fac26cd1722bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e75fac26cd1722bb$var$load("8CqFM").then(()=>parcelRequire('1szz9'));

});

parcelRegister("8DFjK", function(module, exports) {

let $64a20405f6d7df00$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $64a20405f6d7df00$var$load("5bAmA").then(()=>parcelRequire('aBbj7'));

});

parcelRegister("7iUnH", function(module, exports) {

let $5515f2ffc8852585$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5515f2ffc8852585$var$load("i0Evx").then(()=>parcelRequire('84bj3'));

});

parcelRegister("5hoEo", function(module, exports) {

let $3d81a95ceac97d91$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d81a95ceac97d91$var$load("j8OKz").then(()=>parcelRequire('gt5E9'));

});

parcelRegister("h5TZH", function(module, exports) {

let $c71e568d58ce4b9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c71e568d58ce4b9e$var$load("2s1Lz").then(()=>parcelRequire('gqrqX'));

});

parcelRegister("eKtdF", function(module, exports) {

let $abcc06ea6070f8b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abcc06ea6070f8b8$var$load("iI3rq").then(()=>parcelRequire('65XvS'));

});

parcelRegister("i4zsj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c6GJD = parcelRequire("c6GJD");





var $kt8c2 = parcelRequire("kt8c2");

const $171125cd3846f2ee$export$86e2cef2561044ac = (key, defaultValue)=>{
    const storageClient = (0, $42omo.useMemo)(()=>new (0, $kt8c2.default)(key), [
        key
    ]);
    const [value, setValue] = (0, $42omo.useState)(()=>storageClient.getItem(key) ?? defaultValue);
    (0, $42omo.useEffect)(()=>{
        const loadedValue = storageClient.getItem(key) ?? undefined;
        if (loadedValue !== undefined) setValue(loadedValue);
    }, [
        key,
        storageClient
    ]);
    (0, $42omo.useEffect)(()=>{
        storageClient.setItemWithExpiry(key, value);
    }, [
        key,
        storageClient,
        value
    ]);
    return [
        value,
        setValue
    ];
};
function $171125cd3846f2ee$export$6fe28cddb1ee55a2(key, initialValue = [], maxLength = 100) {
    const [records, setRecords] = $171125cd3846f2ee$export$86e2cef2561044ac(key, initialValue);
    const putRecord = (record)=>{
        if (!records) {
            setRecords([
                record
            ]);
            return;
        }
        //just to keep storage limited somehow
        if (maxLength > 0 && records.length > maxLength - 1) records.shift();
        if (records.find((elem)=>JSON.stringify(elem) === JSON.stringify(record)) === undefined) setRecords([
            ...records,
            record
        ]);
    };
    const removeRecord = (query)=>{
        if (!records) return;
        const filtered = records.filter((elem)=>JSON.stringify(elem).indexOf(`"${query}"`) === -1);
        setRecords(filtered);
    };
    const actions = {
        putRecord: putRecord,
        removeRecord: removeRecord
    };
    return {
        records: records,
        actions: actions
    };
}



var $dh538 = parcelRequire("dh538");


var $fDXXi = parcelRequire("fDXXi");


var $iMEBP = parcelRequire("iMEBP");


var $3jKGE = parcelRequire("3jKGE");


var $2z5wT = parcelRequire("2z5wT");


var $fcfcA = parcelRequire("fcfcA");


var $bte6P = parcelRequire("bte6P");


var $dVp1j = parcelRequire("dVp1j");


var $jQbDV = parcelRequire("jQbDV");

const $4bb8c488d8cc97f2$export$20a8aefa6064b33c = (selectedMembers)=>{
    const newUsersWhoNeedInvite = [];
    const existingUsers = [];
    selectedMembers.forEach((selectedMember)=>{
        if (!selectedMember.email && selectedMember.fullName === selectedMember.id) {
            newUsersWhoNeedInvite.push(selectedMember);
            return;
        }
        existingUsers.push(selectedMember);
    });
    return {
        newUsersWhoNeedInvite: newUsersWhoNeedInvite,
        existingUsers: existingUsers
    };
};



var $dTRYM = parcelRequire("dTRYM");


var $cF2M0 = parcelRequire("cF2M0");


var $7C1yo = parcelRequire("7C1yo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gtD4K = parcelRequire("gtD4K");


var $7gpC4 = parcelRequire("7gpC4");





var $bfgIy = parcelRequire("bfgIy");



var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $iBtX5 = parcelRequire("iBtX5");

var $kdU21 = parcelRequire("kdU21");


var $7sG51 = parcelRequire("7sG51");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1s5hv = parcelRequire("1s5hv");




var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");




const $ecbc41255aa486d7$var$DEFAULT_MENU_SKELETON_HEIGHT = 40;
const $ecbc41255aa486d7$var$DEFAULT_CONTENT_HEIGHT = 9;
const $ecbc41255aa486d7$var$menuSkeletonStyles = {
    wrapper: "_4t3i1ylp _1bsb1osq _19bv1b66 _u5f31b66"
}; // Copied from @atlassian/universal-create/skeleton-item to avoid circular dependency
const $ecbc41255aa486d7$export$fbc0ea7debdb77e = ({ testId: testId, contentHeight: contentHeight = $ecbc41255aa486d7$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $ecbc41255aa486d7$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    testId: "skeleton-item-v2",
                    width: "100%",
                    height: contentHeight,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $7sG51.messages).skeletonItemLoading)
            })
        ]
    });
};



var $exlO1 = parcelRequire("exlO1");

const $41c5083138e861f6$export$829a4041f4d056e0 = 'create-team-dialog-create-container-section';
const $41c5083138e861f6$var$styles = {
    stack: "_19pku2gc",
    checkboxContainer: "_19pku2gc",
    label: "_80omtlke",
    button: "_y3gn1e5h _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _bfhk1j28"
};
const $41c5083138e861f6$var$chevronProps = {
    size: 'small',
    label: ''
};
const $41c5083138e861f6$var$productConfig = [
    {
        key: (0, $exlO1.ContainerType).JIRA_PROJECT,
        product: 'jira',
        label: (0, $7sG51.messages).createContainersJira
    },
    {
        key: (0, $exlO1.ContainerType).CONFLUENCE_SPACE,
        product: 'confluence',
        label: (0, $7sG51.messages).createContainersConfluence
    },
    {
        key: (0, $exlO1.ContainerType).LOOM_SPACE,
        product: 'loom',
        label: (0, $7sG51.messages).createContainersLoom
    }
];
function $41c5083138e861f6$export$8d43a29ab91fdd94({ cloudId: cloudId, userId: userId, onChange: onChange }) {
    const [hasSeenThis] = (0, $171125cd3846f2ee$export$86e2cef2561044ac)($41c5083138e861f6$export$829a4041f4d056e0, false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(hasSeenThis ? false : true);
    const [selectedContainers, setSelectedContainers] = (0, $42omo.useState)([]);
    const { data: productPermissions, loading: loading } = (0, $kdU21.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT'
            ],
            loom: [
                'write'
            ],
            confluence: [
                'CREATE_SPACE'
            ]
        }
    });
    const containers = (0, $42omo.useMemo)(()=>{
        const checkPermission = (container)=>{
            if (!productPermissions) return false;
            const product = $41c5083138e861f6$var$productConfig.find((p)=>p.key === container)?.product;
            if (!product) return false;
            return productPermissions ? (0, $iBtX5.hasProductPermission)(productPermissions, product) : false;
        };
        return $41c5083138e861f6$var$productConfig.filter((product)=>checkPermission(product.key)).map((product)=>({
                value: product.key,
                label: product.label
            }));
    }, [
        productPermissions
    ]);
    const handleChange = (event)=>{
        const { value: value, checked: checked } = event.target;
        const container = value;
        setSelectedContainers((prev)=>{
            const newContainers = checked ? [
                ...prev,
                container
            ] : prev.filter((item)=>item !== container);
            onChange(newContainers);
            return newContainers;
        });
    };
    if (loading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $ecbc41255aa486d7$export$fbc0ea7debdb77e), {
        testId: "create-container-skeleton"
    });
    if (!containers || containers.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($41c5083138e861f6$var$ExperimentCheck, {
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $41c5083138e861f6$var$styles.stack,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                    xcss: $41c5083138e861f6$var$styles.button,
                    onClick: ()=>setIsOpen(!isOpen),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Label), {
                        htmlFor: "team-spaces",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "baseline",
                            space: "space.050",
                            xcss: $41c5083138e861f6$var$styles.label,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $7sG51.messages).createContainersLabel
                                }),
                                isOpen ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                                    ...$41c5083138e861f6$var$chevronProps
                                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                    ...$41c5083138e861f6$var$chevronProps
                                })
                            ]
                        })
                    })
                }),
                isOpen ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtlest",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $7sG51.messages).createContainersInfo
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $41c5083138e861f6$var$styles.checkboxContainer,
                            children: containers.map((product)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                                    label: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...product.label
                                        })
                                    }),
                                    value: product.value,
                                    name: `container-${product.value}`,
                                    onChange: handleChange,
                                    isChecked: selectedContainers.includes(product.value)
                                }, product.value))
                        })
                    ]
                }) : null
            ]
        })
    });
}
function $41c5083138e861f6$var$ExperimentCheck({ children: children }) {
    const enrolledInExperiment = (0, $42omo.useMemo)(()=>{
        if ((0, $c6GJD.default).initializeCalled()) return (0, $c6GJD.default).getExperimentValue('teams_app_auto_container_create_universal_create', 'isEnabled', false, {
            fireExperimentExposure: true
        });
        return false;
    }, []);
    if (enrolledInExperiment) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
}






var $kLwto = parcelRequire("kLwto");

/* Form.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");





var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");

var $jVhgp = parcelRequire("jVhgp");


var $cO1el = parcelRequire("cO1el");


var $bPdpL = parcelRequire("bPdpL");


var $1dKyn = parcelRequire("1dKyn");


var $8TTLA = parcelRequire("8TTLA");














var $a502B = parcelRequire("a502B");









var $cIiie = parcelRequire("cIiie");


var $lKErE = parcelRequire("lKErE");




/**
 * @generated SignedSource<<649d487df2c8cc2beb16bf9a639b6ce7>>
 * @relayHash e42e4dd054a2dadff7b10b8b3f62c00e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19531590355e60790126ac534deaf5b99f3df3532b9e58e93d9bc40cf322ab64
const $839cace667c4b7e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scopeId"
        }
    ], v1 = [
        {
            "concreteType": "TeamQuery",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "scopeId",
                            "variableName": "scopeId"
                        }
                    ],
                    "concreteType": "TeamTypeConnection",
                    "kind": "LinkedField",
                    "name": "typesWithinScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "TeamType",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "verified"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "default"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TeamTypeSelectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TeamTypeSelectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "19531590355e60790126ac534deaf5b99f3df3532b9e58e93d9bc40cf322ab64",
            "metadata": {},
            "name": "TeamTypeSelectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$839cace667c4b7e6$var$node.hash = "00cbedec6c8ea92e377a6a929a99eb1c";
var $839cace667c4b7e6$export$2e2bcd8739ae039 = $839cace667c4b7e6$var$node;






var $lAJUP = parcelRequire("lAJUP");





var $irOoi = parcelRequire("irOoi");





var $cO3Oi = parcelRequire("cO3Oi");







var $3hOY6 = parcelRequire("3hOY6");

var $6T8v4 = parcelRequire("6T8v4");


var $iE25L = parcelRequire("iE25L");


var $d4Pk4 = parcelRequire("d4Pk4");


var $gWF6I = parcelRequire("gWF6I");




/* TeamTypeOption.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


















const $32ed8126703433b8$var$messages = (0, $cgtv4.defineMessages)({
    teamTypeDefault: {
        id: "people-teams.team-type-select.team-type-default",
        defaultMessage: "Default type"
    }
});
const $32ed8126703433b8$var$styles = {
    optionWrapper: "_1bsb1osq _80omtlke",
    textWrapper: "_1ul91ris"
};
const $32ed8126703433b8$export$bdc70bcc84ddfbb2 = (props)=>{
    const { data: data } = props;
    const teamTypeData = data.data;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $32ed8126703433b8$var$styles.optionWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.025",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    maxLines: 1,
                                    color: "color.text",
                                    children: teamTypeData?.name
                                })
                            }),
                            teamTypeData?.verified && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                                size: "small",
                                spacing: "none"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.025",
                        children: [
                            teamTypeData?.default && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                        xcss: $32ed8126703433b8$var$styles.textWrapper,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                            color: "color.text.subtlest",
                                            size: "small",
                                            maxLines: 1,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...$32ed8126703433b8$var$messages.teamTypeDefault
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: "\u2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                maxLines: 1,
                                children: teamTypeData?.description
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $a7416767fbec7e86$var$styles = {
    menu: "_1ul91mjv"
};
const $a7416767fbec7e86$var$TeamTypeSingleValue = (props)=>{
    const { data: data } = props;
    const isVerified = data?.data?.verified;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).SingleValue, {
        ...props,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    children: data.label
                }),
                isVerified && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO3Oi.VerifiedTeamIcon), {
                    size: "small",
                    spacing: "none"
                })
            ]
        })
    });
};
const $a7416767fbec7e86$var$TeamTypeSelectInternal = ({ cloudId: cloudId, onChange: onChange })=>{
    const scopeId = (0, $d4Pk4.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
    const data = (0, $irOoi.useLazyLoadQuery)((0, $839cace667c4b7e6$export$2e2bcd8739ae039), {
        scopeId: scopeId
    });
    const teamTypeOptions = (0, $42omo.useMemo)(()=>{
        const nodes = data?.team?.typesWithinScope?.nodes;
        if (!nodes) return [];
        return [
            ...nodes
        ].filter((node)=>node !== null).sort((a, b)=>{
            // Temporart sort for a quick win in FE. Replace it with the backend sort once the type search API is ready.
            const aDefault = a.default;
            const bDefault = b.default; // Priority 1: default === 'VERIFIED'
            const aIsVerifiedDefault = aDefault === 'VERIFIED';
            const bIsVerifiedDefault = bDefault === 'VERIFIED';
            if (aIsVerifiedDefault && !bIsVerifiedDefault) return -1;
            if (!aIsVerifiedDefault && bIsVerifiedDefault) return 1;
             // Priority 2: default has a value
            const aHasDefault = !!aDefault;
            const bHasDefault = !!bDefault;
            if (aHasDefault && !bHasDefault) return -1;
            if (!aHasDefault && bHasDefault) return 1;
             // Priority 3: other types (maintain original order)
            return 0;
        }).map((node)=>({
                label: node.name,
                value: node.id,
                data: {
                    name: node.name,
                    verified: node.verified ?? false,
                    default: !!node.default,
                    description: node.description ?? ''
                }
            }));
    }, [
        data
    ]);
    const defaultTeamType = (0, $42omo.useMemo)(()=>{
        const nodes = data?.team?.typesWithinScope?.nodes;
        if (!nodes) return undefined;
         // Verified default team type is the one we need
        return nodes.find((node)=>node.default === 'VERIFIED') ?? nodes[0];
    }, [
        data
    ]); // This will help with the check for MEMBERSHIP CONTROL section after the default team type is populated
    (0, $42omo.useEffect)(()=>{
        if (defaultTeamType) onChange({
            id: defaultTeamType.id,
            name: defaultTeamType.name,
            verified: defaultTeamType.verified ?? false
        });
        else // Suspense will make sure the component is always rendered after the data is loaded,
        // so it's safe to check the undefined default team type and call onChange with an empty value, to hide the field
        onChange({
            id: '',
            name: '',
            verified: false
        });
    }, [
        onChange,
        defaultTeamType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "teamType",
        isRequired: true,
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamTypeSelectLabel
        }),
        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                inputId: "team-create-team-type-select",
                options: teamTypeOptions,
                defaultValue: defaultTeamType && {
                    label: defaultTeamType.name,
                    value: defaultTeamType.id,
                    data: {
                        name: defaultTeamType.name,
                        verified: defaultTeamType.verified ?? false,
                        default: !!defaultTeamType.default,
                        description: defaultTeamType.description ?? ''
                    }
                },
                components: {
                    Option: (0, $32ed8126703433b8$export$bdc70bcc84ddfbb2),
                    SingleValue: $a7416767fbec7e86$var$TeamTypeSingleValue,
                    Menu: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Menu, {
                            ...props,
                            xcss: $a7416767fbec7e86$var$styles.menu
                        })
                },
                onChange: (newValue)=>{
                    if (onChange && newValue) {
                        const newTeamType = {
                            id: newValue.value ?? '',
                            name: newValue.label ?? '',
                            verified: newValue.data?.verified ?? false
                        };
                        onChange(newTeamType);
                    }
                },
                isRequired: true
            })
    });
};
const $a7416767fbec7e86$export$21f6ad0eb38fd35d = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: null,
        onError: (error)=>{
            (0, $iE25L.logException)(error, 'TeamTypeSelectErrorBoundary');
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                name: "teamType",
                isRequired: true,
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7sG51.messages).teamTypeSelectLabel
                }),
                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6T8v4.default), {
                        isLoading: true
                    })
            }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.RelayEnvironmentProvider), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($a7416767fbec7e86$var$TeamTypeSelectInternal, {
                    ...props
                })
            })
        })
    });
};


















var $7rus4 = parcelRequire("7rus4");

var $RMvle = parcelRequire("RMvle");








var $dsjDS = parcelRequire("dsjDS");





var $98DYt = parcelRequire("98DYt");

const $4790735d6db9ca3b$var$SMART_USER_PICKER_ID = 'AddMemberToTeam';
const $4790735d6db9ca3b$var$LOGGED_IN_USER = 'Context';
function $4790735d6db9ca3b$export$acbf13d3bface7d6(props) {
    const { onChange: onChange, maxSelectedMembers: maxSelectedMembers = (0, $dTRYM.MAX_MEMBERS), cloudId: cloudId, initialValues: initialValues, value: value, teamId: teamId, filterUsers: filterUsers, extraAnalyticsAttrs: extraAnalyticsAttrs, showHelperMessages: showHelperMessages = true, isInvalid: isInvalid, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, inputId: inputId, currentUserEmail: currentUserEmail, allowEmailInvites: allowEmailInvites, bootstrapOptions: bootstrapOptions } = props;
    const [hasError, setError] = (0, $42omo.useState)(false);
    const [isMaximum, setIsMaximum] = (0, $42omo.useState)(false);
    const [isDisabled, setDisabled] = (0, $42omo.useState)(false);
    const [isOpen, setOpen] = (0, $42omo.useState)(false);
    const [query, setQuery] = (0, $42omo.useState)('');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [removedInitialValues, setRemovedInitialValues] = (0, $42omo.useState)(new Set());
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const handleOnChange = (0, $42omo.useCallback)((value)=>{
        const selectedUsers = value || [];
        if (initialValues?.length) {
            const currentIds = new Set(selectedUsers.map((user)=>user.id));
            initialValues.forEach((initUser)=>{
                if (!currentIds.has(initUser.id)) setRemovedInitialValues((prev)=>new Set([
                        ...prev,
                        initUser.id
                    ]));
            });
        }
        setDisabled(selectedUsers.length >= maxSelectedMembers);
        setIsMaximum(selectedUsers.length === maxSelectedMembers);
        const isError = selectedUsers.length > maxSelectedMembers;
        setError(isError);
        fireEvent('track.memberPicker.error', extraAnalyticsAttrs || {});
        if (onChange) onChange(selectedUsers, {
            hasError: isError,
            isDisabled: isDisabled
        });
    }, [
        isDisabled,
        maxSelectedMembers,
        onChange,
        extraAnalyticsAttrs,
        initialValues,
        fireEvent
    ]);
    const handleOnInputChange = (0, $42omo.useCallback)((query)=>{
        setQuery(query || '');
    }, [
        setQuery
    ]);
    const handleOnBlur = (0, $42omo.useCallback)(()=>{
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleOnFocus = (0, $42omo.useCallback)(()=>{
        setOpen(true);
    }, [
        setOpen
    ]);
    // convert InvitedUser type to (OptionalData | User) type of @atlaskit/user-picker
    const memoizedValue = (0, $42omo.useMemo)(()=>{
        const valueUsers = value || [];
        if (initialValues?.length) {
            const uniqueInitialUsers = initialValues.filter((initUser)=>!valueUsers.some((valUser)=>valUser.id === initUser.id) && !removedInitialValues.has(initUser.id));
            const allUsers = [
                ...valueUsers,
                ...uniqueInitialUsers
            ];
            if (!allUsers.length) return undefined;
            return allUsers.map((user)=>({
                    name: user.fullName,
                    publicName: user.nickname,
                    type: (0, $RMvle.UserType),
                    ...user,
                    isSuggestedMember: user.isSuggestedMember
                }));
        }
        // If no initial values, just use current values
        if (valueUsers.length) return valueUsers.map((user)=>({
                name: user.fullName,
                publicName: user.nickname,
                type: (0, $RMvle.UserType),
                ...user,
                isSuggestedMember: user.isSuggestedMember
            }));
    }, [
        value,
        initialValues,
        removedInitialValues
    ]);
    const propsWhenHasError = hasError ? {
        open: false,
        addMoreMessage: ''
    } : {};
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7rus4.default), {
                ariaLabelledBy: ariaLabelledBy,
                "aria-describedby": ariaDescribedBy,
                disableInput: isDisabled,
                onChange: handleOnChange,
                onInputChange: handleOnInputChange,
                onBlur: handleOnBlur,
                onFocus: handleOnFocus,
                open: allowEmailInvites ? undefined : isOpen && query.length > 0,
                includeTeams: false,
                inputId: inputId,
                fieldId: $4790735d6db9ca3b$var$SMART_USER_PICKER_ID,
                principalId: $4790735d6db9ca3b$var$LOGGED_IN_USER,
                isMulti: true,
                placeholder: formatMessage((0, $7sG51.messages).userPickerPlaceholderNext),
                addMoreMessage: allowEmailInvites ? formatMessage((0, $7sG51.messages).enterMore) : '',
                noOptionsMessage: ()=>formatMessage(allowEmailInvites ? (0, $7sG51.messages).userPickerNoOptionWithEmailSuggestion : (0, $7sG51.messages).userPickerNoOption),
                allowEmail: allowEmailInvites ? true : undefined,
                suggestEmailsForDomain: allowEmailInvites ? (0, $dsjDS.getUserDomain)(currentUserEmail) : undefined,
                productKey: "people",
                siteId: cloudId,
                value: memoizedValue,
                debounceTime: (0, $dTRYM.DEBOUNCE_MS),
                width: "100%",
                containerId: teamId || '',
                searchQueryFilter: (0, $98DYt.CPUS_SEARCH_QUERY_FILTER),
                filterOptions: filterUsers,
                maxOptions: (0, $dTRYM.MAX_MEMBERS),
                bootstrapOptions: (0, $dh538.fg)('jira_team_experience_improvements_feature_gate') ? bootstrapOptions : [],
                showClearIndicator: true,
                //@eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                styles: {
                    multiValue: (style)=>({
                            ...style,
                            borderRadius: "var(--ds-radius-small, 4px)",
                            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-input, #8C8F97)"}`
                        }),
                    control: (style, state)=>({
                            ...style,
                            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                            borderColor: isInvalid && !state.isFocused ? "var(--ds-border-danger, #E2483D)" : style.borderColor,
                            ':hover': {
                                ...style[':hover'],
                                borderColor: isInvalid && !state.isFocused ? "var(--ds-border-danger, #E2483D)" : style.borderColor
                            },
                            borderWidth: `var(--ds-border-width, ${isInvalid ? '2px' : '1px'})`,
                            minHeight: '40px',
                            '.fabric-user-picker__clear-indicator': {
                                opacity: 1
                            }
                        })
                },
                ...propsWhenHasError
            }),
            showHelperMessages && (hasError ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageError, {
                    maxNumber: maxSelectedMembers
                })
            }) : isMaximum ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageMaximumError, {
                    maxNumber: maxSelectedMembers
                })
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
                children: formatMessage((0, $7sG51.messages).limitedUsersInvitationMessageInfo, {
                    maxNumber: maxSelectedMembers
                })
            }))
        ]
    });
}
var $4790735d6db9ca3b$export$2e2bcd8739ae039 = $4790735d6db9ca3b$export$acbf13d3bface7d6;


/* TeamMemberSuggestions.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $g5gZt = parcelRequire("g5gZt");









var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");








var $asH6r = parcelRequire("asH6r");





var $5vWho = parcelRequire("5vWho");

const $2fd8093a26d06330$var$DISPLAY_USER_COUNT = 12;
const $2fd8093a26d06330$var$convertAvatarResolution = (avatarUrl, size = 96)=>{
    if (!avatarUrl) return '';
    return avatarUrl.replace(/\/\d+$/, `/${size}`);
};
const $2fd8093a26d06330$var$transformCollaborators = (data)=>{
    if (!data) return [];
    return data.recommendedEntities.filter((user)=>user.expand.account_status === 'active').map((user)=>{
        const { expand: expand } = user;
        return {
            id: (0, $5vWho.parseUserAriToUserId)(user.id),
            name: expand.nickname ? expand.nickname : expand.name,
            picture: $2fd8093a26d06330$var$convertAvatarResolution(expand.picture, 96),
            jobTitle: expand.extended_profile?.job_title,
            location: expand.extended_profile?.location
        };
    });
};
const $2fd8093a26d06330$var$fetchCollaborators = async (accountId, cloudId, maxNumberOfResults)=>{
    return (0, $asH6r.teamsClient).getRecommendedUsers({
        accountId: accountId,
        cloudId: cloudId,
        maxNumberOfResults: maxNumberOfResults
    });
};
const $2fd8093a26d06330$export$7958c2847bf0a62a = (accountId, cloudId)=>{
    const [data, setData] = (0, $42omo.useState)([]);
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(undefined);
    const maxResultsToFetchRef = (0, $42omo.useRef)($2fd8093a26d06330$var$DISPLAY_USER_COUNT);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const loadCollaborators = (0, $42omo.useCallback)(async (isRefetch = false)=>{
        if (!accountId || !cloudId) {
            setLoading(false);
            return;
        }
        try {
            setLoading(true);
            setError(undefined);
            if (isRefetch) maxResultsToFetchRef.current += $2fd8093a26d06330$var$DISPLAY_USER_COUNT;
            const collaborators = await $2fd8093a26d06330$var$fetchCollaborators(accountId, cloudId, maxResultsToFetchRef.current);
            const newUsers = $2fd8093a26d06330$var$transformCollaborators(collaborators);
            setData((prevData)=>{
                if (isRefetch) {
                    const existingIds = new Set(prevData.map((user)=>user.id));
                    const uniqueNewUsers = newUsers.filter((user)=>!existingIds.has(user.id));
                    return [
                        ...prevData,
                        ...uniqueNewUsers
                    ];
                }
                return newUsers;
            });
            fireEvent('operational.teamSuggestionsRecommendedUsers.succeeded', {
                recommendedUsers: newUsers.length
            });
        } catch (err) {
            const error = err instanceof Error ? err : new Error(String(err));
            setError(error);
            (0, $iE25L.logException)(error, 'useTeamCollabQuery.fetchCollaborators', {
                accountId: accountId,
                cloudId: cloudId
            });
            fireEvent('operational.teamSuggestionsRecommendedUsers.failed', {
                recommendedUsers: 0,
                errors: [
                    error?.message ?? 'Failed to fetch recommended users'
                ]
            });
        } finally{
            setLoading(false);
        }
    }, [
        accountId,
        cloudId,
        fireEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        loadCollaborators(false);
    }, [
        loadCollaborators
    ]);
    const refetch = (0, $42omo.useCallback)(async ()=>{
        await loadCollaborators(true);
    }, [
        loadCollaborators
    ]);
    return {
        data: data,
        loading: loading,
        error: error,
        refetch: refetch
    };
};








const $52b323c549eba27b$var$ENTRY_DURATION = 0.36;
const $52b323c549eba27b$var$EXIT_DURATION = 0.12;
const $52b323c549eba27b$var$MAX_SUGGESTED_USERS = 6;
const $52b323c549eba27b$var$styles = {
    container: "_19pkv77o _1bsb1osq _kqswh2mm",
    entry: "_16jlidpf _1o9zkb7n _i0dl1wug _v5644ql6 _p12f1ssb _tzy4idpf _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    base: "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _v5644ql6 _p12f1ssb _tzy4kb7n _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    exit: "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _v564f3tm _p12fidpf _tzy4idpf _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t",
    recommendedUsersTitleContainer: "_syazazsu _1pfhu2gc _6rth1b66"
};
const $52b323c549eba27b$var$SuggestedMemberPill = ({ user: user, onClick: onClick })=>{
    const [animationState, setAnimationState] = (0, $42omo.useState)('entry');
    const handleUserPillClick = ()=>{
        setAnimationState('exit');
        setTimeout(()=>{
            onClick(user);
        }, $52b323c549eba27b$var$EXIT_DURATION * 1000);
    };
    (0, $42omo.useEffect)(()=>{
        setTimeout(()=>setAnimationState('base'));
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: animationState === 'entry' ? $52b323c549eba27b$var$styles.entry : animationState === 'exit' ? $52b323c549eba27b$var$styles.exit : $52b323c549eba27b$var$styles.base,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: user.name,
            ignoreTooltipPointerEvents: true,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                spacing: "compact",
                appearance: "default",
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
                onClick: handleUserPillClick,
                children: user.name
            })
        })
    });
};
const $52b323c549eba27b$var$transformTeamUserToUserPickerUser = (user)=>({
        id: (0, $5vWho.parseUserAriToUserId)(user.id),
        name: user.name,
        publicName: user.name,
        avatarUrl: user.picture,
        type: 'user',
        email: user.email || ''
    });
const $52b323c549eba27b$export$ff316c7db48f6ec0 = ({ onSuggestedUserClick: onSuggestedUserClick, currentPickedUsers: currentPickedUsers, initialValues: initialValues = [], cloudId: cloudId = '', accountId: accountId = '' })=>{
    const { data: teamUsers, loading: isLoading, refetch: refetch } = (0, $2fd8093a26d06330$export$7958c2847bf0a62a)(accountId, cloudId);
    const previousSuggestionCountRef = (0, $42omo.useRef)(0);
    const hasTriggeredRefetchRef = (0, $42omo.useRef)(false);
    const suggestedUsers = teamUsers.map($52b323c549eba27b$var$transformTeamUserToUserPickerUser);
    const filteredSuggestedUsers = suggestedUsers.filter((user)=>!currentPickedUsers.some((pickedUser)=>pickedUser.id === user.id) && !initialValues.some((initialUser)=>initialUser.id === user.id)).slice(0, $52b323c549eba27b$var$MAX_SUGGESTED_USERS);
    (0, $42omo.useEffect)(()=>{
        const currentCount = filteredSuggestedUsers.length;
        const previousCount = previousSuggestionCountRef.current;
        if (previousCount > $52b323c549eba27b$var$MAX_SUGGESTED_USERS - 1 && currentCount === $52b323c549eba27b$var$MAX_SUGGESTED_USERS - 1 && !hasTriggeredRefetchRef.current && !isLoading) {
            hasTriggeredRefetchRef.current = true;
            refetch().then(()=>{
                hasTriggeredRefetchRef.current = false;
            }).catch(()=>{
                hasTriggeredRefetchRef.current = false;
            });
        }
        if (currentCount !== previousCount) previousSuggestionCountRef.current = currentCount;
    }, [
        filteredSuggestedUsers.length,
        refetch,
        isLoading
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $52b323c549eba27b$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small"
        })
    });
    if (!filteredSuggestedUsers.length) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $52b323c549eba27b$var$styles.recommendedUsersTitleContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    weight: "bold",
                    size: "small",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $7sG51.messages).recommendedUsersTitle
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                wrap: "wrap",
                justifyContent: "start",
                alignItems: "center",
                direction: "row",
                xcss: $52b323c549eba27b$var$styles.container,
                children: filteredSuggestedUsers.map((user)=>/*#__PURE__*/ (0, $l998X.jsx)($52b323c549eba27b$var$SuggestedMemberPill, {
                        user: user,
                        onClick: onSuggestedUserClick
                    }, user.id))
            })
        ]
    });
};











var $gmMgo = parcelRequire("gmMgo");


var $1DWH0 = parcelRequire("1DWH0");





var $4noo5 = parcelRequire("4noo5");








var $ko87z = parcelRequire("ko87z");


var $8Hi1J = parcelRequire("8Hi1J");

function $2f9c3dda74688bd3$var$TeamNameInput(props) {
    const { intl: intl, onSubmit: onSubmit, onChange: onChange, isSubmittedOnce: isSubmittedOnce, initialTeamName: initialTeamName } = props;
    const inputRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        inputRef.current && inputRef.current.focus();
    }, []);
    const [name, setName] = (0, $42omo.useState)(initialTeamName);
    const handleTextChange = (0, $42omo.useCallback)((value)=>{
        setName(value || '');
        const teamNameValidationError = (0, $7C1yo.validateTeamName)(value);
        if (isSubmittedOnce && teamNameValidationError === (0, $8Hi1J.ValidationError).REQUIRED) return teamNameValidationError;
        if (teamNameValidationError === (0, $8Hi1J.ValidationError).EXCEED_MAX_LENGTH) return teamNameValidationError;
        onChange(value?.trim() || '');
        return undefined;
    }, [
        onChange,
        isSubmittedOnce
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') {
            event.stopPropagation();
            onSubmit();
        }
    }, [
        onSubmit
    ]);
    const getErrorMsg = (error)=>{
        if (error === (0, $8Hi1J.ValidationError).REQUIRED) return intl.formatMessage((0, $7sG51.messages).teamNameFieldRequiredErrorMessage);
        return intl.formatMessage((0, $7sG51.messages).teamNameFieldTooLongErrorMessage);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "teamName",
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamNameFieldLabelNext
        }),
        isRequired: true,
        validate: handleTextChange,
        defaultValue: initialTeamName,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                        ...fieldProps,
                        autoComplete: "off",
                        isRequired: true,
                        isDisabled: false,
                        name: "teamName",
                        onKeyDown: handleKeyDown,
                        testId: "team-name-input",
                        "aria-labelledby": "",
                        ref: inputRef,
                        value: name
                    }),
                    error ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ko87z.TeamNameErrorMsg), {
                        errorMsg: getErrorMsg(error)
                    }) : null
                ]
            })
    });
}
var $2f9c3dda74688bd3$export$2e2bcd8739ae039 = (0, $1DWH0.default)()((0, $gmMgo.default)($2f9c3dda74688bd3$var$TeamNameInput));


const $d03d138c620dc77f$var$styles = {
    headerStyles: "_otyrutpp",
    footerStyles: "_19pkpxbi",
    recaptchaWrapperStyles: "_19pkutpp",
    fieldStyles: "_zulpze3t"
};
function $d03d138c620dc77f$var$EmptyWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
}
function $d03d138c620dc77f$var$DefaultHeader({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $d03d138c620dc77f$var$styles.headerStyles,
        children: children
    });
}
function $d03d138c620dc77f$var$DefaultFooter({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $d03d138c620dc77f$var$styles.footerStyles,
        children: children
    });
}
function $d03d138c620dc77f$var$FormWrapper(props) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { handleSubmit: handleSubmit, onClose: onClose = (0, $dTRYM.VOID_FUNC), isFetching: isFetching, canCreateTeams: canCreateTeams, showTeamTypePicker: showTeamTypePicker, showTeamTypeSelect: showTeamTypeSelect, onGoBack: onGoBack, teamNameInputProps: teamNameInputProps, memberPickerProps: memberPickerProps, customInputFieldProps: customInputFieldProps, teamTypePickerProps: teamTypePickerProps, teamTypeSelectProps: teamTypeSelectProps, cloudId: cloudId, currentUserId: currentUserId, customMessages: customMessages = {}, customComponents: customComponents = {}, showCreateContainers: showCreateContainers = false, createContainersProps: createContainersProps, handleSuggestedMemberSelection: handleSuggestedMemberSelection, headless: headless } = props;
    const Header = customComponents?.header || customComponents?.modalHeader || $d03d138c620dc77f$var$DefaultHeader;
    const Title = customComponents?.title || customComponents?.modalTitle || $d03d138c620dc77f$var$EmptyWrapper;
    const Body = customComponents?.body || customComponents?.modalBody || $d03d138c620dc77f$var$EmptyWrapper;
    const Footer = customComponents?.footer || customComponents?.modalFooter || $d03d138c620dc77f$var$DefaultFooter;
    const customTitle = customMessages?.title || customMessages?.modalTitle;
    const submitButtonLabel = customMessages?.submitButtonLabel || formatMessage((0, $7sG51.messages).submitButtonLabelNext);
    if (!canCreateTeams) return /*#__PURE__*/ (0, $l998X.jsx)(Body, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cIiie.default), {
            onAction: onClose
        })
    });
    const platformisationFormsEnabled = (0, $dh538.fg)('navx_uc_platformisation_forms_enabled');
    const isTeamMemberSuggestionsEnabled = (0, $c6GJD.default).getExperimentValue('team_member_suggestions_while_creating_team', 'isEnabled', false);
    const hideHeader = headless && platformisationFormsEnabled;
    return (0, $dh538.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        noValidate: true,
        children: [
            !hideHeader && /*#__PURE__*/ (0, $l998X.jsx)(Header, {
                children: /*#__PURE__*/ (0, $l998X.jsx)(Title, {
                    children: (0, $dh538.fg)('enable_close_button_in_team_modals') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.100",
                        spread: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                space: "space.100",
                                children: [
                                    onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        spacing: "compact",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                                ...iconProps
                                            }),
                                        label: formatMessage((0, $7sG51.messages).backButton),
                                        onClick: onGoBack
                                    }) : null,
                                    customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                        alignBlock: "baseline",
                                        space: "space.050",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                                label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                as: "h2",
                                                size: "small",
                                                children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                                onClick: onClose
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        space: "space.100",
                        children: [
                            onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                spacing: "compact",
                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                        ...iconProps
                                    }),
                                label: formatMessage((0, $7sG51.messages).backButton),
                                onClick: onGoBack
                            }) : null,
                            customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "baseline",
                                space: "space.050",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                        label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                        as: "h2",
                                        size: "small",
                                        children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)(Body, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        testId: "create-team-content-dialog",
                        space: "space.100",
                        xcss: platformisationFormsEnabled ? $d03d138c620dc77f$var$styles.fieldStyles : undefined,
                        children: [
                            !hideHeader && /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                size: "small",
                                color: "color.text.subtlest",
                                children: [
                                    formatMessage((0, $7sG51.messages).requiredFieldSummary),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                                ]
                            }),
                            customComponents.customInputField && (()=>{
                                return /*#__PURE__*/ (0, $l998X.jsx)(customComponents.customInputField, {
                                    ...customInputFieldProps()
                                });
                            })(),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $2f9c3dda74688bd3$export$2e2bcd8739ae039), {
                                ...teamNameInputProps
                            }),
                            customComponents.memberPicker ? /*#__PURE__*/ (0, $l998X.jsx)(customComponents.memberPicker, {
                                ...memberPickerProps()
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                name: "inviteMembers",
                                label: formatMessage((0, $7sG51.messages).invitationsFieldLabelNext),
                                id: "inviteMembers",
                                isRequired: true,
                                defaultValue: memberPickerProps().initialValues || [],
                                children: ({ fieldProps: fieldProps, error: error })=>{
                                    const { showErrorMessage: showErrorMessage, ...props } = memberPickerProps(error);
                                    const suggestedMembersCloudId = cloudId;
                                    const suggestedMembersAccountId = currentUserId;
                                    const handleSuggestedUserClick = (selectedUser)=>{
                                        const currentValue = fieldProps.value || [];
                                        const isUserAlreadySelected = currentValue.some((user)=>user.id === selectedUser.id);
                                        if (isUserAlreadySelected) return;
                                        const newInvitedUser = {
                                            id: selectedUser.id,
                                            email: selectedUser.email || '',
                                            fullName: selectedUser.name,
                                            nickname: selectedUser.publicName,
                                            avatarUrl: selectedUser.avatarUrl,
                                            isSuggestedMember: true
                                        };
                                        const newValue = [
                                            ...currentValue,
                                            newInvitedUser
                                        ];
                                        if (handleSuggestedMemberSelection) handleSuggestedMemberSelection(newInvitedUser);
                                        fieldProps.onChange(newValue);
                                        if (props.onChange) {
                                            const newUserPickerUsers = newValue.map((user)=>({
                                                    id: user.id,
                                                    name: user.fullName,
                                                    publicName: user.nickname,
                                                    avatarUrl: user.avatarUrl,
                                                    type: 'user',
                                                    email: user.email,
                                                    isSuggestedMember: user.isSuggestedMember
                                                }));
                                            props.onChange(newUserPickerUsers, {
                                                hasError: false,
                                                isDisabled: false
                                            });
                                        }
                                    }; // Convert InvitedUser[] to UserPickerUser[] for SuggestedTeamMembers
                                    const userPickerUsers = (fieldProps.value || []).map((user)=>({
                                            id: user.id,
                                            name: user.fullName,
                                            publicName: user.nickname,
                                            avatarUrl: user.avatarUrl,
                                            type: 'user',
                                            email: user.email
                                        }));
                                    const initialUserPickerUsers = (props.initialValues || []).map((user)=>({
                                            id: user.id,
                                            name: user.fullName,
                                            publicName: user.nickname,
                                            avatarUrl: user.avatarUrl,
                                            type: 'user',
                                            email: user.email
                                        }));
                                    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $4790735d6db9ca3b$export$2e2bcd8739ae039), {
                                                ...fieldProps,
                                                ...props,
                                                value: fieldProps.value,
                                                ariaLabelledBy: `${fieldProps.id}-label`,
                                                ariaDescribedBy: `${fieldProps.id}-helper`,
                                                inputId: fieldProps.id,
                                                onChange: (users, meta)=>{
                                                    const invitedUsers = users.map((user)=>({
                                                            id: user.id,
                                                            email: user.email || '',
                                                            fullName: user.name,
                                                            nickname: user.publicName,
                                                            avatarUrl: user.avatarUrl,
                                                            isSuggestedMember: user?.isSuggestedMember || false
                                                        }));
                                                    fieldProps.onChange(invitedUsers); // Also call the original onChange from memberPickerProps
                                                    if (props.onChange) props.onChange(users, meta);
                                                },
                                                initialValues: props.initialValues
                                            }),
                                            isTeamMemberSuggestionsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $52b323c549eba27b$export$ff316c7db48f6ec0), {
                                                currentPickedUsers: userPickerUsers,
                                                onSuggestedUserClick: handleSuggestedUserClick,
                                                initialValues: initialUserPickerUsers,
                                                cloudId: suggestedMembersCloudId,
                                                accountId: suggestedMembersAccountId
                                            }),
                                            showErrorMessage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                testId: "invitation-field-empty-error",
                                                children: formatMessage((0, $7sG51.messages).invitationsFieldErrorMessageNext)
                                            }) : null
                                        ]
                                    });
                                }
                            }),
                            showTeamTypeSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a7416767fbec7e86$export$21f6ad0eb38fd35d), {
                                ...teamTypeSelectProps
                            }) : null,
                            showTeamTypePicker ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lKErE.default), {
                                ...teamTypePickerProps
                            }) : null,
                            showCreateContainers ? /*#__PURE__*/ (0, $l998X.jsx)((0, $41c5083138e861f6$export$8d43a29ab91fdd94), {
                                ...createContainersProps
                            }) : null
                        ]
                    }),
                    memberPickerProps()?.allowEmailInvites ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $d03d138c620dc77f$var$styles.recaptchaWrapperStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            color: "color.text.subtle",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a502B.default), {})
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: (0, $dh538.fg)('jsm_ux_uplift') ? 'subtle' : 'default',
                        onClick: onClose,
                        children: formatMessage((0, $7sG51.messages).cancelButtonLabel)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        appearance: "primary",
                        isLoading: isFetching,
                        type: "submit",
                        children: submitButtonLabel
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $l998X.jsxs)("form", {
                ...formProps,
                noValidate: true,
                children: [
                    !hideHeader && /*#__PURE__*/ (0, $l998X.jsx)(Header, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)(Title, {
                            children: (0, $dh538.fg)('enable_close_button_in_team_modals') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                space: "space.100",
                                spread: "space-between",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                        alignBlock: "center",
                                        space: "space.100",
                                        children: [
                                            onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                                spacing: "compact",
                                                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                                        ...iconProps
                                                    }),
                                                label: formatMessage((0, $7sG51.messages).backButton),
                                                onClick: onGoBack
                                            }) : null,
                                            customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                                alignBlock: "baseline",
                                                space: "space.050",
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                                        label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                        as: "h2",
                                                        size: "small",
                                                        children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                                        onClick: onClose
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                alignBlock: "center",
                                space: "space.100",
                                children: [
                                    onGoBack ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        spacing: "compact",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPdpL))), {
                                                ...iconProps
                                            }),
                                        label: formatMessage((0, $7sG51.messages).backButton),
                                        onClick: onGoBack
                                    }) : null,
                                    customTitle ? customTitle : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                                        alignBlock: "baseline",
                                        space: "space.050",
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dKyn))), {
                                                label: formatMessage((0, $7sG51.messages).modalTitleIconLabel)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                                as: "h2",
                                                size: "small",
                                                children: formatMessage((0, $7sG51.messages).modalTitleNext)
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)(Body, {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                testId: "create-team-content-dialog",
                                space: "space.100",
                                xcss: platformisationFormsEnabled ? $d03d138c620dc77f$var$styles.fieldStyles : undefined,
                                children: [
                                    !hideHeader && /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
                                        size: "small",
                                        color: "color.text.subtlest",
                                        children: [
                                            formatMessage((0, $7sG51.messages).requiredFieldSummary),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {})
                                        ]
                                    }),
                                    customComponents.customInputField && (()=>{
                                        return /*#__PURE__*/ (0, $l998X.jsx)(customComponents.customInputField, {
                                            ...customInputFieldProps()
                                        });
                                    })(),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2f9c3dda74688bd3$export$2e2bcd8739ae039), {
                                        ...teamNameInputProps
                                    }),
                                    customComponents.memberPicker ? /*#__PURE__*/ (0, $l998X.jsx)(customComponents.memberPicker, {
                                        ...memberPickerProps()
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                                        name: "inviteMembers",
                                        label: formatMessage((0, $7sG51.messages).invitationsFieldLabelNext),
                                        id: "inviteMembers",
                                        isRequired: true,
                                        defaultValue: memberPickerProps().initialValues || [],
                                        children: ({ fieldProps: fieldProps, error: error })=>{
                                            const { showErrorMessage: showErrorMessage, ...props } = memberPickerProps(error);
                                            const suggestedMembersCloudId = cloudId;
                                            const suggestedMembersAccountId = currentUserId; // Handle suggested user selection
                                            const handleSuggestedUserClick = (selectedUser)=>{
                                                const currentValue = fieldProps.value || []; // Check if user is already selected
                                                const isUserAlreadySelected = currentValue.some((user)=>user.id === selectedUser.id);
                                                if (isUserAlreadySelected) return;
                                                 // Create new invited user
                                                const newInvitedUser = {
                                                    id: selectedUser.id,
                                                    email: selectedUser.email || '',
                                                    fullName: selectedUser.name,
                                                    nickname: selectedUser.publicName,
                                                    avatarUrl: selectedUser.avatarUrl,
                                                    isSuggestedMember: true
                                                }; // Merge with existing selection
                                                const newValue = [
                                                    ...currentValue,
                                                    newInvitedUser
                                                ];
                                                if (handleSuggestedMemberSelection) handleSuggestedMemberSelection(newInvitedUser);
                                                fieldProps.onChange(newValue);
                                                if (props.onChange) {
                                                    const newUserPickerUsers = newValue.map((user)=>({
                                                            id: user.id,
                                                            name: user.fullName,
                                                            publicName: user.nickname,
                                                            avatarUrl: user.avatarUrl,
                                                            type: 'user',
                                                            email: user.email,
                                                            isSuggestedMember: user.isSuggestedMember
                                                        }));
                                                    props.onChange(newUserPickerUsers, {
                                                        hasError: false,
                                                        isDisabled: false
                                                    });
                                                }
                                            }; // Convert InvitedUser[] to UserPickerUser[] for SuggestedTeamMembers
                                            const userPickerUsers = (fieldProps.value || []).map((user)=>({
                                                    id: user.id,
                                                    name: user.fullName,
                                                    publicName: user.nickname,
                                                    avatarUrl: user.avatarUrl,
                                                    type: 'user',
                                                    email: user.email
                                                })); // Convert initialValues to UserPickerUser[]
                                            const initialUserPickerUsers = (props.initialValues || []).map((user)=>({
                                                    id: user.id,
                                                    name: user.fullName,
                                                    publicName: user.nickname,
                                                    avatarUrl: user.avatarUrl,
                                                    type: 'user',
                                                    email: user.email
                                                }));
                                            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $4790735d6db9ca3b$export$2e2bcd8739ae039), {
                                                        ...fieldProps,
                                                        ...props,
                                                        value: fieldProps.value,
                                                        ariaLabelledBy: `${fieldProps.id}-label`,
                                                        ariaDescribedBy: `${fieldProps.id}-helper`,
                                                        inputId: fieldProps.id,
                                                        onChange: (users, meta)=>{
                                                            const invitedUsers = users.map((user)=>({
                                                                    id: user.id,
                                                                    email: user.email || '',
                                                                    fullName: user.name,
                                                                    nickname: user.publicName,
                                                                    avatarUrl: user.avatarUrl,
                                                                    isSuggestedMember: user?.isSuggestedMember || false
                                                                }));
                                                            fieldProps.onChange(invitedUsers); // Also call the original onChange from memberPickerProps
                                                            if (props.onChange) props.onChange(users, meta);
                                                        },
                                                        initialValues: props.initialValues
                                                    }),
                                                    isTeamMemberSuggestionsEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $52b323c549eba27b$export$ff316c7db48f6ec0), {
                                                        currentPickedUsers: userPickerUsers,
                                                        onSuggestedUserClick: handleSuggestedUserClick,
                                                        initialValues: initialUserPickerUsers,
                                                        cloudId: suggestedMembersCloudId,
                                                        accountId: suggestedMembersAccountId
                                                    }),
                                                    showErrorMessage ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                                        testId: "invitation-field-empty-error",
                                                        children: formatMessage((0, $7sG51.messages).invitationsFieldErrorMessageNext)
                                                    }) : null
                                                ]
                                            });
                                        }
                                    }),
                                    showTeamTypeSelect ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a7416767fbec7e86$export$21f6ad0eb38fd35d), {
                                        ...teamTypeSelectProps
                                    }) : null,
                                    showTeamTypePicker ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lKErE.default), {
                                        ...teamTypePickerProps
                                    }) : null,
                                    showCreateContainers ? /*#__PURE__*/ (0, $l998X.jsx)((0, $41c5083138e861f6$export$8d43a29ab91fdd94), {
                                        ...createContainersProps
                                    }) : null
                                ]
                            }),
                            memberPickerProps()?.allowEmailInvites ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $d03d138c620dc77f$var$styles.recaptchaWrapperStyles,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a502B.default), {})
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)(Footer, {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: (0, $dh538.fg)('jsm_ux_uplift') ? 'subtle' : 'default',
                                onClick: onClose,
                                children: formatMessage((0, $7sG51.messages).cancelButtonLabel)
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "primary",
                                isLoading: isFetching,
                                type: "submit",
                                children: submitButtonLabel
                            })
                        ]
                    })
                ]
            })
    });
}
var $d03d138c620dc77f$export$2e2bcd8739ae039 = $d03d138c620dc77f$var$FormWrapper;



var $cEyfH = parcelRequire("cEyfH");





var $inPa6 = parcelRequire("inPa6");





var $hYSRS = parcelRequire("hYSRS");


var $8ftiF = parcelRequire("8ftiF");











var $g6zY9 = parcelRequire("g6zY9");


var $cpl2G = parcelRequire("cpl2G");


var $erMpQ = parcelRequire("erMpQ");








var $8zu5m = parcelRequire("8zu5m");




function $2d52b5011f6e7de7$var$useTeamCreateConfiguration(props) {
    const { product: product, onCreateTeamSuccess: onCreateTeamSuccess = (0, $dTRYM.VOID_FUNC), onCreateTeamFailed: onCreateTeamFailed = (0, $dTRYM.VOID_FUNC), addFlag: addFlag = (0, $dTRYM.VOID_FUNC), pushRoute: pushRoute = (0, $dTRYM.VOID_FUNC), disableSuccessFlag: disableSuccessFlag, extraAnalyticsAttrs: extraAnalyticsAttrs, initialMembershipSettings: initialMembershipSettings, enableMembershipSettingsChoice: enableMembershipSettingsChoice } = props;
    const peopleAndTeamsConfiguration = (0, $g6zY9.usePeopleAndTeamsConfigurationContext)();
    const remoteConfigResources = peopleAndTeamsConfiguration?.['people-menu']?.resources || null;
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { triggerAnalyticsForCreateTeamSuccess: triggerAnalyticsForCreateTeamSuccessNext, triggerAnalyticsForCreateTeamFailed: triggerAnalyticsForCreateTeamFailedNext } = (0, $dVp1j.default)();
    const handleOnClickTeamLinkInFlag = (0, $42omo.useCallback)((event, teamData, invitedMembers)=>{
        event.preventDefault();
        fireEvent('ui.teamCreateDialog.clicked.teamLinkSuccessFlag', {
            teamId: teamData.id,
            numberOfMembers: invitedMembers.length,
            ...extraAnalyticsAttrs
        });
        // redirect to team page
        pushRoute((0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
            remoteConfigResources: remoteConfigResources,
            teamId: teamData.id,
            ref: product,
            src: (0, $8zu5m.AnalyticsSource).PEOPLE_TEAMS,
            orgId: props.orgId
        }));
    }, [
        extraAnalyticsAttrs,
        product,
        props.orgId,
        remoteConfigResources,
        pushRoute,
        fireEvent
    ]);
    const handleCreateTeamSuccess = (0, $42omo.useCallback)(async (teamData, invitedMembers, failedInvitedMembers, containers, numberOfSuggestedMembers)=>{
        triggerAnalyticsForCreateTeamSuccessNext({
            numberOfMembers: invitedMembers.length,
            numberOfSuggestedMembers: numberOfSuggestedMembers ?? 0,
            teamId: teamData.id,
            defaultTeamType: initialMembershipSettings || null,
            chosenTeamType: teamData.membershipSettings,
            teamTypeChoiceEnabled: enableMembershipSettingsChoice || null,
            ...extraAnalyticsAttrs
        });
        const result = await onCreateTeamSuccess(teamData, invitedMembers, failedInvitedMembers, containers, numberOfSuggestedMembers);
        const requestedContainers = result !== undefined ? result?.requestedContainers : undefined;
        if (failedInvitedMembers && failedInvitedMembers.length > 0) addFlag({
            title: formatMessage((0, $7sG51.messages).flagErrorCreateTeamPartialFailTitle),
            description: formatMessage((0, $7sG51.messages).flagErrorCreateTeamPartialFailDesc),
            appearance: 'error',
            id: 'create.team.failed'
        });
        if (!disableSuccessFlag) addFlag({
            title: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamTitle),
            description: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamDesc),
            appearance: 'success',
            id: 'create.team.success',
            actions: [
                {
                    content: formatMessage((0, $7sG51.messages).flagSuccessCreateTeamAction),
                    onClick: (event)=>handleOnClickTeamLinkInFlag(event, teamData, invitedMembers),
                    href: (0, $erMpQ.getTeamProfilePageLinkWithOrgId)({
                        remoteConfigResources: remoteConfigResources,
                        teamId: teamData.id,
                        ref: product,
                        src: (0, $8zu5m.AnalyticsSource).PEOPLE_TEAMS,
                        orgId: props.orgId,
                        containers: requestedContainers
                    })
                }
            ]
        });
    }, [
        initialMembershipSettings,
        enableMembershipSettingsChoice,
        extraAnalyticsAttrs,
        onCreateTeamSuccess,
        disableSuccessFlag,
        addFlag,
        formatMessage,
        remoteConfigResources,
        props.orgId,
        product,
        handleOnClickTeamLinkInFlag,
        triggerAnalyticsForCreateTeamSuccessNext
    ]);
    const handleCreateTeamFailed = (0, $42omo.useCallback)((error, invitedMembers)=>{
        if ((0, $cpl2G.isSeriousError)(error)) triggerAnalyticsForCreateTeamFailedNext({
            numberOfMembers: invitedMembers.length,
            errorMessage: error.message,
            errorStack: error.stack || null,
            errorStatus: error.status,
            traceId: error.traceId || null,
            ...extraAnalyticsAttrs
        });
        onCreateTeamFailed(error, invitedMembers);
        if (addFlag) addFlag({
            title: formatMessage((0, $7sG51.messages).flagErrorCreateTeamTitle),
            description: formatMessage((0, $7sG51.messages).flagErrorCreateTeamDesc),
            appearance: 'error',
            id: 'create.team.failed'
        });
    }, [
        onCreateTeamFailed,
        addFlag,
        extraAnalyticsAttrs,
        formatMessage,
        triggerAnalyticsForCreateTeamFailedNext
    ]);
    return {
        onCreateTeamSuccess: handleCreateTeamSuccess,
        onCreateTeamFailed: handleCreateTeamFailed
    };
}
var $2d52b5011f6e7de7$export$2e2bcd8739ae039 = $2d52b5011f6e7de7$var$useTeamCreateConfiguration;


function $7e2123ed2a31706e$var$useTeamCreateMutation(props) {
    const { onCreateTeamSuccess: onCreateTeamSuccess, onCreateTeamFailed: onCreateTeamFailed } = (0, $2d52b5011f6e7de7$export$2e2bcd8739ae039)(props);
    const { cloudId: cloudId, orgId: orgId, product: product } = props;
    const [selectedMembers, setSelectedMembers] = (0, $42omo.useState)([]);
    const [numberOfSuggestedMembers, setNumberOfSuggestedMembers] = (0, $42omo.useState)(0);
    // need a state to keep sync status of 2 requests: Create team and Invite members
    const [isFetching, setIsFetching] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { loading: isCreatingTeam, error: errorCreateTeam, data: teamData, createTeam: createTeam } = (0, $8ftiF.useCreateTeamService)(cloudId, product, undefined, orgId);
    // This function is used to create teams
    const handleCreateTeamWithMembers = (0, $42omo.useCallback)((teamName, requestedMembers, membershipSettings, typeId, suggestedMembersCount)=>{
        if (isCreatingTeam) return;
        setSelectedMembers(requestedMembers);
        setNumberOfSuggestedMembers(suggestedMembersCount ?? 0);
        setIsFetching(true);
        const memberIds = requestedMembers.map((member)=>member.id);
        return createTeam(teamName, membershipSettings, memberIds, typeId);
    }, [
        createTeam,
        isCreatingTeam
    ]);
    const isFinishedCreateTeam = !errorCreateTeam && !isCreatingTeam && teamData;
    // call callbacks for creating teams
    (0, $hYSRS.useOnceWhen)(!!(isFinishedCreateTeam || errorCreateTeam), async ()=>{
        // always call onCreateTeamSuccess when creating team successfully, though inviting members can fail
        // since users can work around by re-inviting members in the team profile page.
        if (isFinishedCreateTeam) {
            const successfullyInvitedMembers = (0, $dh538.fg)('handle_partial_create_team_failures') ? selectedMembers.filter((m)=>teamData.memberIds?.includes(m.id)) : selectedMembers;
            const failedInvitedMembers = (0, $dh538.fg)('handle_partial_create_team_failures') ? selectedMembers.filter((m)=>!teamData.memberIds?.includes(m.id)) : undefined;
            await onCreateTeamSuccess(teamData, successfullyInvitedMembers, failedInvitedMembers, undefined, numberOfSuggestedMembers);
            setIsFetching(false);
        }
        if (errorCreateTeam) {
            onCreateTeamFailed(errorCreateTeam, selectedMembers);
            // no need to invite anyone to team as members already invited
            setIsFetching(false);
        }
    }, [
        errorCreateTeam,
        isFinishedCreateTeam,
        onCreateTeamFailed,
        onCreateTeamSuccess,
        selectedMembers,
        numberOfSuggestedMembers,
        teamData,
        setIsFetching,
        createAnalyticsEvent,
        product
    ]);
    return {
        isFetching: isFetching,
        createTeamAndAddMembers: handleCreateTeamWithMembers
    };
}
var $7e2123ed2a31706e$export$2e2bcd8739ae039 = $7e2123ed2a31706e$var$useTeamCreateMutation;


function $eca4ef8232acf504$var$TeamCreate(props) {
    const { proposedMembers: proposedMembers = [], cloudId: cloudId, maxSelectedMembers: maxSelectedMembers = (0, $dTRYM.MAX_MEMBERS), extraAnalyticsAttrs: extraAnalyticsAttrs, enableMembershipSettingsChoice: enableMembershipSettingsChoice, initialMembershipSettings: initialMembershipSettings = enableMembershipSettingsChoice ? (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY : (0, $jQbDV.TeamMembershipSettings).OPEN, setIsLoading: setIsLoading = (0, $dTRYM.VOID_FUNC), onClose: onClose = (0, $dTRYM.VOID_FUNC), customMessages: customMessages = {}, customComponents: customComponents = {}, currentUser: currentUser, orgId: orgId, enableTeamPermissionCheck: enableTeamPermissionCheck, prepopulatedFields: prepopulatedFields = {}, onGoBack: onGoBack, hideCreateContainers: hideCreateContainers = false, headless: headless = false, onCreateClicked: onCreateClicked } = props;
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { triggerAnalyticsForSubmitTeamCreateDialog: triggerAnalyticsForSubmitTeamCreateDialogNext } = (0, $dVp1j.default)();
    const isEligibleProductForInvites = props.product === 'jira' || props.product === 'atlas';
    const { canInviteToJiraSoftware: canInviteToJiraSoftware, canInviteToConfluence: canInviteToConfluence } = (0, $bte6P.useInviteCapabilities)({
        cloudId: cloudId,
        shouldRun: isEligibleProductForInvites && (0, $dh538.fg)('jira_team_experience_improvements_feature_gate')
    });
    const isTeamExperienceImprovementEnabled = isEligibleProductForInvites && canInviteToJiraSoftware && (0, $c6GJD.default).initializeCalled() && (0, $c6GJD.default).getExperimentValue('jira_team_experience_improvements', 'isEnabled', false);
    const inviteAndAddToTeam = (0, $fcfcA.useInviteAndAddToTeam)({
        products: (0, $cF2M0.getInviteProducts)({
            product: props.product,
            canInviteToJiraSoftware: canInviteToJiraSoftware,
            canInviteToConfluence: canInviteToConfluence
        }),
        originProduct: props.product
    });
    const [_, setHaveISeenContainers] = (0, $171125cd3846f2ee$export$86e2cef2561044ac)((0, $41c5083138e861f6$export$829a4041f4d056e0), false);
    const showCreateContainers = (0, $42omo.useMemo)(()=>{
        if (hideCreateContainers) return false;
        if (!currentUser?.id) return false;
        if ((0, $c6GJD.default).initializeCalled()) return (0, $c6GJD.default).getExperimentValue('teams_app_auto_container_create_universal_create', 'isEnabled', false, {
            fireExperimentExposure: false
        });
        return false;
    }, [
        currentUser?.id,
        hideCreateContainers
    ]);
    const [containers, setCreateContainers] = (0, $42omo.useState)([]);
    const onCreateTeamSuccess = async (teamData, invitedMembers, failedInvitedMembers)=>{
        let requestedContainers = [];
        if (teamData.id && containers.length > 0 && showCreateContainers) {
            setHaveISeenContainers(true);
            const payload = containers.map((container)=>({
                    type: container,
                    containerSiteId: cloudId
                }));
            /*
				This is not be awaited due to performance reasons.
				These requests can take multiple seconds, so we don't want to block the UI.
			*/ (0, $2z5wT.postCreateTeamContainers)({
                teamId: teamData.id,
                containers: payload
            });
            requestedContainers = payload.map((container)=>container.type);
            fireEvent('track.requestedContainers.requested', {
                containers: Object.values((0, $exlO1.ContainerType)).reduce((acc, type)=>{
                    acc[type] = containers?.includes(type) ?? false;
                    return acc;
                }, {}),
                ...extraAnalyticsAttrs
            });
        }
        if (isTeamExperienceImprovementEnabled) {
            const { newUsersWhoNeedInvite: newUsersWhoNeedInvite } = (0, $4bb8c488d8cc97f2$export$20a8aefa6064b33c)(selectedMembers);
            // This is similarly not awaited for performance reasons.
            inviteAndAddToTeam({
                newUsersWhoNeedInvite: newUsersWhoNeedInvite,
                cloudId: cloudId,
                teamId: teamData.id,
                orgId: orgId
            });
        }
        if (props?.onCreateTeamSuccess) await props.onCreateTeamSuccess(teamData, invitedMembers, failedInvitedMembers, requestedContainers, suggestedMembers.length);
        return {
            requestedContainers: requestedContainers,
            numberOfSuggestedMembers: suggestedMembers.length
        };
    };
    const { isFetching: mutationIsLoading, createTeamAndAddMembers: createTeamAndAddMembers } = (0, $7e2123ed2a31706e$export$2e2bcd8739ae039)({
        ...props,
        onCreateTeamSuccess: onCreateTeamSuccess
    });
    const { members: proposedMembersNext, membershipSettings: initialMembershipSettingsNext, teamName: initialTeamName } = prepopulatedFields;
    const [teamName, setTeamName] = (0, $42omo.useState)(initialTeamName || '');
    const [isFetching, setIsFetching] = (0, $42omo.useState)(false);
    const [membershipSettings, setMembershipSettings] = (0, $42omo.useState)(initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings);
    const [selectedMembers, setSelectedMembers] = (0, $42omo.useState)([]);
    const [suggestedMembers, setSuggestedMembers] = (0, $42omo.useState)([]);
    const [isSubmittedOnce, setIsSubmittedOnce] = (0, $42omo.useState)(false);
    const [isMemberPickerInvalid, setIsMemberPickerInvalid] = (0, $42omo.useState)(false);
    const [isCustomInputFieldInvalid, setIsCustomInputFieldInvalid] = (0, $42omo.useState)(true);
    (0, $cEyfH.useContainerPermissionsAnalyticsEvent)(cloudId, currentUser?.id);
    const { loading: loading, permissions: permissions } = (0, $3jKGE.useTeamsPermissionsService)({
        orgId: orgId,
        cloudId: cloudId
    }, {
        enabled: !!enableTeamPermissionCheck,
        attributes: {
            userId: currentUser?.id
        }
    });
    // When team type is enabled, we want to hide the Membership Control by default for admins, to avoid the UI friction while loading types options
    const [showTeamTypePickerState, setShowTeamTypePickerState] = (0, $42omo.useState)((0, $dh538.fg)('enable_atlassian_team_types_m1') ? false : Boolean(enableMembershipSettingsChoice));
    const [showTeamTypeSelect, setShowTeamTypeSelect] = (0, $42omo.useState)(false);
    const [teamType, setTeamType] = (0, $42omo.useState)();
    const proposedMembersWithCurrentUser = (0, $42omo.useMemo)(()=>{
        const members = [
            ...proposedMembersNext ? proposedMembersNext : proposedMembers,
            ...currentUser && currentUser.id ? [
                currentUser
            ] : []
        ];
        const uniqueMembers = members.filter((member, index, self)=>index === self.findIndex((m)=>m.id === member.id));
        return uniqueMembers;
    }, [
        proposedMembersNext,
        proposedMembers,
        currentUser
    ]);
    // When team permission is loaded, we decide to render these or not based on permissions.
    (0, $42omo.useEffect)(()=>{
        if (!loading && permissions && (0, $dh538.fg)('enable_atlassian_team_types_m1')) {
            setShowTeamTypePickerState(!permissions.canAdminTeams && Boolean(enableMembershipSettingsChoice));
            setShowTeamTypeSelect(Boolean(permissions.canAdminTeams));
        }
    }, [
        loading,
        permissions,
        enableMembershipSettingsChoice
    ]);
    // did mount
    (0, $42omo.useEffect)(()=>{
        setSelectedMembers(proposedMembersWithCurrentUser);
        fireEvent('screen.teamCreateDialog.viewed', {
            proposedMembersLength: (proposedMembersNext ? proposedMembersNext : proposedMembers).length,
            ...extraAnalyticsAttrs
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        setIsFetching(!!mutationIsLoading);
        setIsLoading(!!mutationIsLoading || loading);
        // when isFetching prop change from true --> false, that means the creating team finishes
        if (mutationIsLoading === false && isFetching === true) onClose();
    }, [
        mutationIsLoading,
        isFetching,
        setIsLoading,
        onClose,
        loading
    ]);
    const handleSelectedChange = (0, $42omo.useCallback)((users, data)=>{
        setSelectedMembers(users.map((user)=>({
                id: user.id,
                email: user.email,
                fullName: user.name,
                avatarUrl: user.avatarUrl
            })));
        setSuggestedMembers((existingSuggestedMembers)=>existingSuggestedMembers.filter((suggestedMember)=>users.find((user)=>user.id === suggestedMember.id)));
        setIsMemberPickerInvalid(data.hasError || users.length === 0);
    }, [
        setIsMemberPickerInvalid,
        setSelectedMembers
    ]);
    const handleChange = (0, $42omo.useCallback)((customInput)=>{
        const isInvalid = !customInput || !customInput.value;
        setIsCustomInputFieldInvalid(isInvalid);
    }, [
        setIsCustomInputFieldInvalid
    ]);
    const handleSuggestedMemberSelection = (0, $42omo.useCallback)((newValue)=>{
        fireEvent('ui.member.suggested', {
            userId: newValue.id,
            ...extraAnalyticsAttrs
        });
        setSuggestedMembers((existingSuggestedMembers)=>[
                ...existingSuggestedMembers,
                newValue
            ]);
    }, [
        extraAnalyticsAttrs,
        setSuggestedMembers,
        fireEvent
    ]);
    const handleTeamTypeSelectChange = (0, $42omo.useCallback)((value)=>{
        // Hide the Team Type Select when no value, which means there was no team type at all exists in the user base
        if (!value.id) {
            setShowTeamTypeSelect(false);
            setTeamType(undefined);
        } else setTeamType(value.id);
        // Show the MEMBERSHIP CONTROL section when the team type is not verified
        setShowTeamTypePickerState(!value.verified);
        if (value.verified) setMembershipSettings((0, $jQbDV.TeamMembershipSettings).ORG_ADMIN_MANAGED);
        else setMembershipSettings(initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings);
    }, [
        setShowTeamTypeSelect,
        setShowTeamTypePickerState,
        initialMembershipSettingsNext,
        initialMembershipSettings
    ]);
    const canTeamBeCreated = (0, $42omo.useCallback)(()=>{
        const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
        const hasCustomField = Boolean(customComponents?.customInputField);
        const result = !isMemberPickerInvalid && !teamNameValidationError && (!hasCustomField || !isCustomInputFieldInvalid) && !isFetching;
        return result;
    }, [
        isFetching,
        isMemberPickerInvalid,
        isCustomInputFieldInvalid,
        teamName,
        customComponents?.customInputField
    ]);
    const handleSubmit = (0, $42omo.useCallback)(()=>{
        triggerAnalyticsForSubmitTeamCreateDialogNext({
            canCreateTeam: canTeamBeCreated(),
            numberOfMembers: selectedMembers.length,
            numberOfSuggestedMembers: suggestedMembers.length,
            ...extraAnalyticsAttrs
        });
        setIsSubmittedOnce(true);
        onCreateClicked?.({
            teamName: teamName,
            selectedMembers: selectedMembers,
            membershipSettings: membershipSettings
        });
        if (!canTeamBeCreated()) {
            const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
            return {
                teamName: teamNameValidationError,
                inviteMembers: selectedMembers.length === 0
            };
        }
        if (canTeamBeCreated()) {
            setIsFetching(true);
            // outsource creating a new team + invite members logic to outside
            // to reduce complexity of current file
            createTeamAndAddMembers(teamName, selectedMembers, membershipSettings, teamType, suggestedMembers.length);
        }
    }, [
        onCreateClicked,
        teamName,
        selectedMembers,
        membershipSettings,
        canTeamBeCreated,
        triggerAnalyticsForSubmitTeamCreateDialogNext,
        suggestedMembers.length,
        extraAnalyticsAttrs,
        createTeamAndAddMembers,
        teamType
    ]);
    const handleSubmitForExistingUsers = (0, $42omo.useCallback)(async ()=>{
        triggerAnalyticsForSubmitTeamCreateDialogNext({
            canCreateTeam: canTeamBeCreated(),
            numberOfMembers: selectedMembers.length,
            numberOfSuggestedMembers: suggestedMembers.length,
            ...extraAnalyticsAttrs
        });
        setIsSubmittedOnce(true);
        onCreateClicked?.({
            teamName: teamName,
            selectedMembers: selectedMembers,
            membershipSettings: membershipSettings
        });
        if (!canTeamBeCreated()) {
            const teamNameValidationError = (0, $7C1yo.validateTeamName)(teamName);
            return {
                teamName: teamNameValidationError,
                inviteMembers: selectedMembers.length === 0
            };
        }
        const { existingUsers: existingUsers } = (0, $4bb8c488d8cc97f2$export$20a8aefa6064b33c)(selectedMembers);
        setIsFetching(true);
        createTeamAndAddMembers(teamName, existingUsers, membershipSettings, teamType, suggestedMembers.length);
    }, [
        canTeamBeCreated,
        createTeamAndAddMembers,
        extraAnalyticsAttrs,
        membershipSettings,
        selectedMembers,
        suggestedMembers,
        teamName,
        triggerAnalyticsForSubmitTeamCreateDialogNext,
        onCreateClicked,
        teamType
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d03d138c620dc77f$export$2e2bcd8739ae039), {
        headless: headless,
        handleSubmit: isTeamExperienceImprovementEnabled ? handleSubmitForExistingUsers : handleSubmit,
        onClose: onClose,
        isFetching: isFetching,
        canCreateTeams: permissions.canCreateTeams,
        maxSelectedMembers: maxSelectedMembers,
        customMessages: customMessages,
        customComponents: customComponents,
        showTeamTypePicker: showTeamTypePickerState,
        showTeamTypeSelect: showTeamTypeSelect,
        showCreateContainers: showCreateContainers,
        onGoBack: onGoBack,
        handleSuggestedMemberSelection: handleSuggestedMemberSelection,
        cloudId: cloudId,
        currentUserId: currentUser?.id,
        teamNameInputProps: {
            onChange: setTeamName,
            onSubmit: handleSubmit,
            isSubmittedOnce: isSubmittedOnce,
            initialTeamName: initialTeamName
        },
        memberPickerProps: (error)=>({
                cloudId: cloudId,
                onChange: handleSelectedChange,
                initialValues: proposedMembersWithCurrentUser,
                maxSelectedMembers: maxSelectedMembers,
                extraAnalyticsAttrs: extraAnalyticsAttrs,
                showHelperMessages: false,
                isInvalid: isSubmittedOnce ? isMemberPickerInvalid : !!error,
                showErrorMessage: Boolean(isSubmittedOnce ? isMemberPickerInvalid : error),
                currentUserEmail: currentUser?.email,
                allowEmailInvites: isTeamExperienceImprovementEnabled,
                bootstrapOptions: isTeamExperienceImprovementEnabled ? undefined : []
            }),
        customInputFieldProps: (error)=>{
            const props = {
                orgId: orgId || '',
                isRequired: true,
                isInvalid: isSubmittedOnce ? isCustomInputFieldInvalid : !!error,
                showErrorMessage: Boolean(isSubmittedOnce ? isCustomInputFieldInvalid : error),
                onChange: handleChange
            };
            return props;
        },
        teamTypePickerProps: {
            onChange: setMembershipSettings,
            defaultValue: initialMembershipSettingsNext ? initialMembershipSettingsNext : initialMembershipSettings
        },
        teamTypeSelectProps: {
            cloudId: cloudId,
            onChange: handleTeamTypeSelectChange
        },
        createContainersProps: {
            cloudId: cloudId,
            //verified userId is truthy in showCreateContainers
            userId: currentUser?.id,
            onChange: setCreateContainers
        }
    });
}
const $eca4ef8232acf504$var$TeamCreateWithLazyIntlProvider = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iMEBP.LazyIntlProvider), {
        fetchLanguageFile: (0, $kLwto.fetchLanguageFile),
        children: /*#__PURE__*/ (0, $l998X.jsx)($eca4ef8232acf504$var$TeamCreate, {
            ...props
        })
    });
};
var $eca4ef8232acf504$export$2e2bcd8739ae039 = $eca4ef8232acf504$var$TeamCreateWithLazyIntlProvider;
module.exports["default"] = $eca4ef8232acf504$export$2e2bcd8739ae039;

});

parcelRegister("2z5wT", function(module, exports) {

var $asH6r = parcelRequire("asH6r");

// src/identity/team-type/types.ts
var $83ba7276a71fc72c$export$e1ed78e1f6fcb85d = "identity", $83ba7276a71fc72c$export$5e4a4c44ec9508eb = "team-type";



var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/identity/team-type/manifest.ts
var $e6582f18894900ee$var$identityTeamTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $83ba7276a71fc72c$export$e1ed78e1f6fcb85d),
    resourceType: (0, $83ba7276a71fc72c$export$5e4a4c44ec9508eb),
    resourceIdSlug: "{directoryId}/{teamTypeId}",
    resourceIdSegmentFormats: {
        directoryId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        teamTypeId: /[a-zA-Z0-9.\-_~]{1,64}/
    }
};
// src/identity/team-type/index.ts
var $e6582f18894900ee$export$691365bd52dea848 = class _IdentityTeamTypeAri extends (0, $3NXcb.RegisteredAri) {
    get directoryId() {
        return this._directoryId;
    }
    get teamTypeId() {
        return this._teamTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.qualifier,
            platformQualifier: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.resourceOwner,
            resourceType: $e6582f18894900ee$var$identityTeamTypeAriStaticOpts.resourceType,
            resourceId: `${opts.directoryId}/${opts.teamTypeId}`,
            resourceIdSegmentValues: {
                directoryId: opts.directoryId,
                teamTypeId: opts.teamTypeId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $e6582f18894900ee$var$identityTeamTypeAriStaticOpts);
        return new _IdentityTeamTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $e6582f18894900ee$var$identityTeamTypeAriStaticOpts);
        return new _IdentityTeamTypeAri(opts);
    }
    getVariables() {
        return {
            directoryId: this.directoryId,
            teamTypeId: this.teamTypeId
        };
    }
    constructor(opts){
        super(opts), this._directoryId = opts.resourceIdSegmentValues.directoryId, this._teamTypeId = opts.resourceIdSegmentValues.teamTypeId;
    }
};



var $erMpQ = parcelRequire("erMpQ");


var $jQbDV = parcelRequire("jQbDV");


var $3PCpU = parcelRequire("3PCpU");


var $dAQwn = parcelRequire("dAQwn");


var $5vWho = parcelRequire("5vWho");

const $24be8a5f4fdf4242$var$LIMIT_RESULTS = 5;
const $24be8a5f4fdf4242$export$51eb1e4b266d279a = '/gateway/api';
const $24be8a5f4fdf4242$export$a6635dd972d6facf = `${$24be8a5f4fdf4242$export$51eb1e4b266d279a}/v3/teams`;
const $24be8a5f4fdf4242$export$8ebb304bc6fdbba2 = `${$24be8a5f4fdf4242$export$51eb1e4b266d279a}/v4/teams`;
const $24be8a5f4fdf4242$export$d6cee1ef1aa86c6d = `${$24be8a5f4fdf4242$export$a6635dd972d6facf}/of-user`;
const $24be8a5f4fdf4242$export$5c5040d455d75334 = `${$24be8a5f4fdf4242$export$8ebb304bc6fdbba2}/search`;
const $24be8a5f4fdf4242$export$2964ca5e058bf0b = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    const params = [
        `limit=${$24be8a5f4fdf4242$var$LIMIT_RESULTS}`,
        'cursor=',
        `organizationId=${orgId ?? ''}`,
        `origin.cloudId=${cloudId}`,
        `origin.product=${product.toUpperCase()}`
    ];
    return `${tenantUrl}${$24be8a5f4fdf4242$export$d6cee1ef1aa86c6d}/${userId}?&${params.join('&')}`;
};
const $24be8a5f4fdf4242$export$8c9e20a1ace4ac54 = (cloudId, product, tenantUrl = '')=>`${tenantUrl}${$24be8a5f4fdf4242$export$5c5040d455d75334}${(0, $erMpQ.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
const $24be8a5f4fdf4242$export$d084da02a78b32a4 = (userId, cloudId, product, tenantUrl = '', orgId)=>orgId ? (0, $dAQwn.fetchJson)($24be8a5f4fdf4242$export$2964ca5e058bf0b(userId, cloudId, product, tenantUrl, orgId)) : new Promise(()=>{});
const $24be8a5f4fdf4242$export$c52386bca71fd065 = (userId, cloudId, product, tenantUrl = '', orgId)=>{
    if (!userId || !cloudId || !orgId) throw new (0, $3PCpU.ErrorWithContext)('Missing parameters', {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        product: product,
        tenantUrl: tenantUrl
    });
    const url = $24be8a5f4fdf4242$export$8c9e20a1ace4ac54(cloudId, product, tenantUrl);
    const postData = {
        organizationId: orgId,
        siteId: cloudId,
        limit: $24be8a5f4fdf4242$var$LIMIT_RESULTS,
        membership: {
            memberAccountIds: [
                userId
            ]
        }
    };
    return (0, $dAQwn.postJson)(url, postData);
};
const $24be8a5f4fdf4242$export$db3c0c162386baf4 = async (teamName, membershipSettings, metaData)=>{
    (0, $asH6r.teamsClient).setContext({
        cloudId: metaData.cloudId,
        orgId: metaData.orgId
    });
    (0, $asH6r.teamsClient).setBaseUrl(`${metaData.tenantUrl ?? ''}${$24be8a5f4fdf4242$export$51eb1e4b266d279a}`);
    const result = await (0, $asH6r.teamsClient).createTeam(teamName, {
        product: metaData.product
    }, [
        ...new Set(metaData.members)
    ], membershipSettings, // The Team create API expects team type ID instead of ARI
    metaData.typeId ? (0, $e6582f18894900ee$export$691365bd52dea848).check(metaData.typeId) ? (0, $e6582f18894900ee$export$691365bd52dea848).parse(metaData.typeId).teamTypeId : metaData.typeId : undefined);
    return {
        id: result.id,
        displayName: result.displayName,
        description: result.description,
        state: result.state === 'ACTIVE' ? (0, $jQbDV.TeamState).ACTIVE : (0, $jQbDV.TeamState).PURGED,
        membershipSettings: (0, $5vWho.getMembershipSettings)(result.membershipSettings),
        memberCount: result.memberIds?.length ?? 0,
        teamAri: `ari:cloud:teams::team/${result.id}`,
        discoverable: (0, $jQbDV.TeamDiscoverability).DISCOVERABLE,
        organizationId: result.organizationId,
        restriction: (0, $jQbDV.TeamRestriction).NO_RESTRICTION,
        creatorId: result.creatorId,
        memberIds: result.memberIds,
        permission: result.permission === 'FULL_WRITE' ? (0, $jQbDV.TeamPermission).FULL_WRITE : result.permission === 'FULL_READ' ? (0, $jQbDV.TeamPermission).FULL_READ : (0, $jQbDV.TeamPermission).NONE
    };
};
const $24be8a5f4fdf4242$export$27c5962a642c1a90 = async (payload, tenantUrl)=>{
    if (!payload.teamId || !payload.containers || payload.containers.length === 0) return;
    (0, $asH6r.teamsClient).setBaseUrl(`${tenantUrl ?? ''}${$24be8a5f4fdf4242$export$51eb1e4b266d279a}`);
    const result = await (0, $asH6r.teamsClient).createTeamContainers(payload);
    return {
        teamId: result.teamId,
        containersNotCreated: result.containersNotCreated,
        containersCreated: result.containersCreated
    };
};
const $24be8a5f4fdf4242$export$76780145274bc285 = (teamId, { product: product, cloudId: cloudId, tenantUrl: tenantUrl = '' })=>{
    return `${tenantUrl}${$24be8a5f4fdf4242$export$a6635dd972d6facf}/ui/${teamId}/membership/invite${(0, $erMpQ.constructProductOriginParams)({
        product: product,
        cloudId: cloudId
    })}`;
};
const $24be8a5f4fdf4242$export$9cb3b92426f8e2eb = async (teamId, users, metaData)=>{
    if (!users || users.length === 0) return Promise.resolve(undefined);
    const emails = [];
    const ids = [];
    users.forEach((user)=>{
        if (user.id) ids.push(user.id);
        else if (user.email) emails.push(user.email);
    });
    const url = $24be8a5f4fdf4242$export$76780145274bc285(teamId, metaData);
    const postData = {
        emailAddresses: emails,
        atlassianAccounts: ids
    };
    return (0, $dAQwn.postJson)(url, postData);
};
module.exports["searchTeamsOfUser"] = $24be8a5f4fdf4242$export$c52386bca71fd065;
module.exports["postCreateTeam"] = $24be8a5f4fdf4242$export$db3c0c162386baf4;
module.exports["postCreateTeamContainers"] = $24be8a5f4fdf4242$export$27c5962a642c1a90;

});

parcelRegister("7C1yo", function(module, exports) {

var $8Hi1J = parcelRequire("8Hi1J");

const $e3371b5b6d0ab65d$export$6f7ed7f72d9991fb = (teamName)=>{
    if (!teamName) return (0, $8Hi1J.ValidationError).REQUIRED;
    if (teamName.length > 100) return (0, $8Hi1J.ValidationError).EXCEED_MAX_LENGTH;
    return undefined;
};
module.exports["validateTeamName"] = $e3371b5b6d0ab65d$export$6f7ed7f72d9991fb;

});

parcelRegister("8Hi1J", function(module, exports) {
var $4e712b808bb97b5a$export$2191b9da168c6cf0 = /*#__PURE__*/ function(ValidationError) {
    /**
	 * Error type when the required field not filled
	 */ ValidationError["REQUIRED"] = "required";
    ValidationError["EXCEED_MAX_LENGTH"] = "exceed_max_length";
    return ValidationError;
}({});
module.exports["ValidationError"] = $4e712b808bb97b5a$export$2191b9da168c6cf0;

});

parcelRegister("cIiie", function(module, exports) {
/* NoAccessErrorState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $abC4X = parcelRequire("abC4X");


var $7sG51 = parcelRequire("7sG51");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");

const $b0aab7220676f1ef$var$AccessLockSVG = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "191",
        height: "222",
        viewBox: "0 0 191 222",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white",
                        fillOpacity: "0.01"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
                        fill: "#FF991F"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
                        fill: "#FFC400"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("g", {
                        style: {
                            mixBlendMode: 'multiply'
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
                            fill: "#FFE380"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
                        fill: "#FFAB00"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
                        fill: "#253858"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
                        fill: "#0065FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
                        fill: "#2684FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
                        fill: "#FFFAE5"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
                        fill: "#FFFAE5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M0 0.400391H190.2V221.9H0V0.400391Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var $b0aab7220676f1ef$export$2e2bcd8739ae039 = $b0aab7220676f1ef$var$AccessLockSVG;


const $5e2c5c2e6d57a768$var$compiledStyles = {
    accessLockSVGWrapper: "_otyroahv",
    actionButtonWrapper: "_19pku2gc"
};
const $5e2c5c2e6d57a768$var$NoAccessErrorState = ({ onAction: onAction })=>{
    const intl = (0, $8C5kA.default)();
    const action = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $5e2c5c2e6d57a768$var$compiledStyles.actionButtonWrapper
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            onClick: onAction,
            appearance: "primary",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $7sG51.messages).noAccessErrorStateActionLabel
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
        header: intl.formatMessage((0, $7sG51.messages).noAccessErrorStateTitle),
        description: intl.formatMessage((0, $7sG51.messages).noAccessErrorStateMessage),
        primaryAction: action,
        renderImage: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $5e2c5c2e6d57a768$var$compiledStyles.accessLockSVGWrapper
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $b0aab7220676f1ef$export$2e2bcd8739ae039), {})
            })
    });
};
var $5e2c5c2e6d57a768$export$2e2bcd8739ae039 = $5e2c5c2e6d57a768$var$NoAccessErrorState;
module.exports["default"] = $5e2c5c2e6d57a768$export$2e2bcd8739ae039;

});

parcelRegister("lKErE", function(module, exports) {
/* TeamTypePicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $7gpC4 = parcelRequire("7gpC4");


var $fb3kw = parcelRequire("fb3kw");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $fDXXi = parcelRequire("fDXXi");


var $jQbDV = parcelRequire("jQbDV");


var $7sG51 = parcelRequire("7sG51");

const $7f4f61323b2e207e$var$compiledStyles = {
    checkboxLine: "_1e0c1txw _4cvr1h6o",
    openMembershipDescriptionAnchor: "_1e0c1bgi",
    openMembershipDescription: "_ahbq1b66"
};
const $7f4f61323b2e207e$export$d1c0f3d85a1ba244 = ({ defaultValue: defaultValue, onChange: onChange })=>{
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const [isMembershipOpen, setIsMembershipOpen] = (0, $42omo.useState)(defaultValue === (0, $jQbDV.TeamMembershipSettings).OPEN);
    const handleChange = (0, $42omo.useCallback)((event)=>{
        const chosenValue = event.currentTarget.checked ? (0, $jQbDV.TeamMembershipSettings).OPEN : (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY;
        fireEvent('ui.teamTypePicker.clicked', {
            defaultType: defaultValue || null,
            chosenType: chosenValue
        });
        setIsMembershipOpen(chosenValue === (0, $jQbDV.TeamMembershipSettings).OPEN);
        onChange(chosenValue);
    }, [
        defaultValue,
        onChange,
        fireEvent
    ]);
    const label = /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        size: "small",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamTypeCheckboxLabel
        })
    });
    if ((0, $dh538.fg)('ptc-unblock-confluence-permissions-changes')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
                name: "teamType",
                label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7sG51.messages).teamTypePickerLabel
                }),
                children: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $7f4f61323b2e207e$var$compiledStyles.checkboxLine
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                            name: "teamType",
                            defaultChecked: defaultValue === (0, $jQbDV.TeamMembershipSettings).OPEN,
                            onChange: handleChange,
                            label: label
                        })
                    })
            }),
            isMembershipOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $7f4f61323b2e207e$var$compiledStyles.openMembershipDescription,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtlest",
                    size: "small",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $7sG51.messages).teamOpenMembershipDisclaimer,
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                    href: "https://support.atlassian.com/platform-experiences/docs/start-an-atlassian-team/#Understanding-membership-controls",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    xcss: $7f4f61323b2e207e$var$compiledStyles.openMembershipDescriptionAnchor,
                                    children: chunks
                                })
                        }
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        name: "teamType",
        label: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $7sG51.messages).teamTypePickerLabel
        }),
        children: ()=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $7f4f61323b2e207e$var$compiledStyles.checkboxLine
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
                    name: "teamType",
                    defaultChecked: defaultValue === (0, $jQbDV.TeamMembershipSettings).OPEN,
                    onChange: handleChange,
                    label: label
                })
            })
    });
};
var $7f4f61323b2e207e$export$2e2bcd8739ae039 = $7f4f61323b2e207e$export$d1c0f3d85a1ba244;
module.exports["default"] = $7f4f61323b2e207e$export$2e2bcd8739ae039;

});

parcelRegister("98DYt", function(module, exports) {
/**
 * Filter out inactive users AND bot accounts
 */ const $091db23b095dff1e$export$e8eb9b725485707a = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:"app")';
module.exports["CPUS_SEARCH_QUERY_FILTER"] = $091db23b095dff1e$export$e8eb9b725485707a;

});

parcelRegister("ko87z", function(module, exports) {
/* TeamNameVisibilityWarning.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gQhRa = parcelRequire("gQhRa");


var $eXmBZ = parcelRequire("eXmBZ");


var $3gadb = parcelRequire("3gadb");


var $7sG51 = parcelRequire("7sG51");

const $231c3eb2f7d43136$var$compiledStyles = {
    infoPopupLearnMoreWrapper: "_1e0c1ule _19pku2gc",
    divWrapper: "_1e0c1txw _4cvr1h6o",
    infoIconWrapper: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _18u01b66 _c71lpxbi"
};
function $231c3eb2f7d43136$export$71f8f57e8cade4f9() {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $231c3eb2f7d43136$var$compiledStyles.infoPopupLearnMoreWrapper
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("a", {
            target: "_blank",
            rel: "noreferrer",
            href: "#",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $7sG51.messages).learnMore
            })
        })
    });
}
function $231c3eb2f7d43136$export$ab1a3f0c3cd5e68e({ errorMsg: errorMsg }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
        testId: "team-name-empty-error",
        children: errorMsg
    });
}
function $231c3eb2f7d43136$export$1a4118ee85eefa24() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
        testId: "team-name-info-msg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            className: (0, $gMc0m.default)([
                $231c3eb2f7d43136$var$compiledStyles.divWrapper
            ]),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $7sG51.messages).teamNameFieldInfoMessage
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: formatMessage((0, $7sG51.messages).teamNameFieldInfoDetail),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        tabIndex: 0,
                        role: "button",
                        className: (0, $gMc0m.default)([
                            $231c3eb2f7d43136$var$compiledStyles.infoIconWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                            label: formatMessage((0, $7sG51.messages).teamNameFieldInfoDetail),
                            color: "currentColor",
                            size: "small"
                        })
                    })
                })
            ]
        })
    });
}
module.exports["TeamNameErrorMsg"] = $231c3eb2f7d43136$export$ab1a3f0c3cd5e68e;
module.exports["TeamNameInfoMsg"] = $231c3eb2f7d43136$export$1a4118ee85eefa24;

});

parcelRegister("cEyfH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fDXXi = parcelRequire("fDXXi");


var $iBtX5 = parcelRequire("iBtX5");

var $kdU21 = parcelRequire("kdU21");

function $21b1ba75ec6b9e3e$export$8adaae1490083cd6(cloudId, userId) {
    const { loading: loading, data: data, error: error } = (0, $kdU21.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT'
            ],
            loom: [
                'write'
            ],
            confluence: [
                'CREATE_SPACE'
            ]
        }
    });
    const hasFiredRef = (0, $42omo.useRef)(false);
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (loading || !data || Object.keys(data).length === 0 || error || hasFiredRef.current) return;
        const attributes = {
            canCreateConfluenceContainer: data ? (0, $iBtX5.hasProductPermission)(data, 'confluence', [
                'CREATE_SPACE'
            ]) : false,
            canCreateLoomContainer: data ? (0, $iBtX5.hasProductPermission)(data, 'loom', [
                'write'
            ]) : false,
            canCreateJiraContainer: data ? (0, $iBtX5.hasProductPermission)(data, 'jira', [
                'CREATE_PROJECT'
            ]) : false
        };
        fireEvent('track.containerPermissions.succeeded', {
            canCreateConfluenceContainer: attributes.canCreateConfluenceContainer || false,
            canCreateLoomContainer: attributes.canCreateLoomContainer || false,
            canCreateJiraContainer: attributes.canCreateJiraContainer || false
        });
        hasFiredRef.current = true;
    }, [
        loading,
        data,
        error,
        fireEvent
    ]);
}
module.exports["useContainerPermissionsAnalyticsEvent"] = $21b1ba75ec6b9e3e$export$8adaae1490083cd6;

});

parcelRegister("8ftiF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2z5wT = parcelRequire("2z5wT");


var $8WLH9 = parcelRequire("8WLH9");


var $jQbDV = parcelRequire("jQbDV");


var $1y96J = parcelRequire("1y96J");

function $1052eef51deec84c$export$55536fa0740b1330(cloudId, product, tenantUrl, orgId) {
    const [teamInfo, setTeamInfo] = (0, $42omo.useState)({
        teamName: '',
        teamMembershipSettings: (0, $jQbDV.TeamMembershipSettings).OPEN
    });
    const requestToCreateTeam = (0, $42omo.useCallback)(()=>{
        const metaData = {
            product: product,
            cloudId: cloudId,
            tenantUrl: tenantUrl,
            orgId: orgId,
            members: teamInfo.teamMembers,
            typeId: teamInfo.typeId
        };
        return (0, $2z5wT.postCreateTeam)(teamInfo.teamName, teamInfo.teamMembershipSettings, metaData);
    }, [
        cloudId,
        product,
        tenantUrl,
        teamInfo,
        orgId
    ]);
    const { loading: loading, error: error, data: data, fetchData: fetchData } = (0, $1y96J.useService)(requestToCreateTeam);
    const memoizedData = (0, $42omo.useMemo)(()=>(0, $8WLH9.trimTeamAriInObject)(data), [
        data
    ]);
    // calling creating team endpoint when teamName change
    (0, $42omo.useEffect)(()=>{
        if (!teamInfo.teamName) return;
        fetchData();
    }, [
        fetchData,
        teamInfo
    ]);
    return {
        loading: loading,
        error: error,
        data: memoizedData,
        createTeam: (teamName, teamMembershipSettings, teamMembers, typeId)=>{
            // `teamName` changes --> `requestToCreateTeam` is updated -->  `fetchData` is updated --> `memoizedData` is updated
            setTeamInfo({
                teamName: teamName,
                teamMembershipSettings: teamMembershipSettings,
                ...teamMembers && teamMembers.length > 0 && {
                    teamMembers: teamMembers
                },
                typeId: typeId
            });
        }
    };
}
module.exports["useCreateTeamService"] = $1052eef51deec84c$export$55536fa0740b1330;

});

parcelRegister("8WLH9", function(module, exports) {
function $f6f03925f485eb7e$export$c75c12ecb0b3724e(team) {
    if (!team) return team;
    return {
        ...team,
        id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
    };
}
const $f6f03925f485eb7e$export$fd398a52d6f57b46 = (data)=>{
    if (!data || !data.entities) return [];
    return data.entities.map($f6f03925f485eb7e$export$c75c12ecb0b3724e);
};
module.exports["trimTeamAriInObject"] = $f6f03925f485eb7e$export$c75c12ecb0b3724e;
module.exports["transformTeams"] = $f6f03925f485eb7e$export$fd398a52d6f57b46;

});

parcelRegister("1y96J", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $7ef83ecb9005e49e$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setStateRaw] = (0, $42omo.useState)({
        loading: false,
        ...initialState
    });
    const isMounted = (0, $42omo.useRef)(true);
    (0, $42omo.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    });
    const setState = (0, $42omo.useCallback)((state)=>{
        if (isMounted.current) setStateRaw(state);
    }, []);
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request();
            setState({
                loading: false,
                error: undefined,
                data: data
            });
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
        }
    }, [
        request,
        setState
    ]);
    return {
        ...state,
        fetchData: fetchData
    };
};
module.exports["useService"] = $7ef83ecb9005e49e$export$6de4685a6c88b4e9;

});

parcelRegister("1UbNf", function(module, exports) {
const $bc45907eae291e90$export$836e07406b35f36c = ({ products: products, cloudId: cloudId })=>{
    return products.map((product)=>`ari:cloud:${product}::site/${cloudId}`);
};
module.exports["getProductAris"] = $bc45907eae291e90$export$836e07406b35f36c;

});

parcelRegister("5vWho", function(module, exports) {

var $gHaxX = parcelRequire("gHaxX");


var $jQbDV = parcelRequire("jQbDV");

const $5b0eaa56a681b9bd$export$7a41eaabcfe7ab13 = (setting)=>{
    switch(setting){
        case 'OPEN':
            return (0, $jQbDV.TeamMembershipSettings).OPEN;
        case 'MEMBER_INVITE':
            return (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY;
        case 'ORG_ADMIN_MANAGED':
            return (0, $jQbDV.TeamMembershipSettings).ORG_ADMIN_MANAGED;
        default:
            return (0, $jQbDV.TeamMembershipSettings).INVITE_ONLY;
    }
};
const $5b0eaa56a681b9bd$export$6844af0be884cf1 = (ariId)=>{
    try {
        return (0, $gHaxX.IdentityUserAri).parse(ariId).userId;
    } catch  {
        return ariId;
    }
};
module.exports["getMembershipSettings"] = $5b0eaa56a681b9bd$export$7a41eaabcfe7ab13;
module.exports["parseUserAriToUserId"] = $5b0eaa56a681b9bd$export$6844af0be884cf1;

});


//# sourceMappingURL=TeamProfileCardEntryPoint.28c80f5c.js.map
